"use strict";
/*
 * --------------------------------------------------------------------------------------------------------------------
 * <copyright file="HxActorAPIs.ts" company="Microsoft">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * <summary>
 *   !!! This is an automatically generated file for Actor APIs to serialize command args and invoke hxcomm's RunActor method !!!
 *   Please run `MakeGenFiles.bat Actors` from the hxcomm/tools/bin
 *   directory to update its contents.
 * </summary>
 * Generating File: ActorAPIsJs.tt
 * --------------------------------------------------------------------------------------------------------------------
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFailureResults = exports.HxActorAPIs = void 0;
var HxEnums = __importStar(require("./HxObjectEnums"));
var HxFailureResultsWithData_1 = require("./HxFailureResultsWithData");
var HxActorCompletion_1 = __importDefault(require("./HxActorCompletion"));
var HxActorCompletionInfo_1 = __importDefault(require("./HxActorCompletionInfo"));
var HxActorId_1 = __importDefault(require("./HxActorId"));
var HxActorWithResultsCompletion_1 = __importDefault(require("./HxActorWithResultsCompletion"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxAddAttachmentFileToDraftArgs_1 = require("./HxAddAttachmentFileToDraftArgs");
var HxAddAttachmentFileToDraftResults_1 = require("./HxAddAttachmentFileToDraftResults");
var HxAddBlockedSenderAndDomainArgs_1 = require("./HxAddBlockedSenderAndDomainArgs");
var HxAddDelegatesArgs_1 = require("./HxAddDelegatesArgs");
var HxAddFavoriteItemResults_1 = require("./HxAddFavoriteItemResults");
var HxAddFavoritePersonArgs_1 = require("./HxAddFavoritePersonArgs");
var HxAddFeedSubscriptionArgs_1 = require("./HxAddFeedSubscriptionArgs");
var HxAddHolidayCalendarArgs_1 = require("./HxAddHolidayCalendarArgs");
var HxAddInInfoArgs_1 = require("./HxAddInInfoArgs");
var HxAddRecipientArgs_1 = require("./HxAddRecipientArgs");
var HxAddRecipientResults_1 = require("./HxAddRecipientResults");
var HxAddSharedCalendarBySmtpArgs_1 = require("./HxAddSharedCalendarBySmtpArgs");
var HxArchiveMailItemArgs_1 = require("./HxArchiveMailItemArgs");
var HxBoolArgs_1 = require("./HxBoolArgs");
var HxCalendarDataResults_1 = require("./HxCalendarDataResults");
var HxCallGenericRestApiArgs_1 = require("./HxCallGenericRestApiArgs");
var HxCallOutlookRestApiArgs_1 = require("./HxCallOutlookRestApiArgs");
var HxCallOutlookRestApiResults_1 = require("./HxCallOutlookRestApiResults");
var HxCancelCalendarEventArgs_1 = require("./HxCancelCalendarEventArgs");
var HxCategorizeMailItemArgs_1 = require("./HxCategorizeMailItemArgs");
var HxCertificateArgs_1 = require("./HxCertificateArgs");
var HxClearMipLabelArgs_1 = require("./HxClearMipLabelArgs");
var HxClearUnseenFocusOtherNotificationsArgs_1 = require("./HxClearUnseenFocusOtherNotificationsArgs");
var HxCloseAnswersSearchArgs_1 = require("./HxCloseAnswersSearchArgs");
var HxCloseAttachmentSearchArgs_1 = require("./HxCloseAttachmentSearchArgs");
var HxCloseCalendarSearchArgs_1 = require("./HxCloseCalendarSearchArgs");
var HxCloseFilesSearchArgs_1 = require("./HxCloseFilesSearchArgs");
var HxCloseICSFileArgs_1 = require("./HxCloseICSFileArgs");
var HxCloseMailSearchArgs_1 = require("./HxCloseMailSearchArgs");
var HxClosePeopleSearchArgs_1 = require("./HxClosePeopleSearchArgs");
var HxCloseRecipientSearchArgs_1 = require("./HxCloseRecipientSearchArgs");
var HxCloseTopSearchArgs_1 = require("./HxCloseTopSearchArgs");
var HxCloseVCFFileArgs_1 = require("./HxCloseVCFFileArgs");
var HxContactArgs_1 = require("./HxContactArgs");
var HxCopyMailItemArgs_1 = require("./HxCopyMailItemArgs");
var HxCreateAccountArgs_1 = require("./HxCreateAccountArgs");
var HxCreateAccountResults_1 = require("./HxCreateAccountResults");
var HxCreateCalendarArgs_1 = require("./HxCreateCalendarArgs");
var HxCreateCalendarItemArgs_1 = require("./HxCreateCalendarItemArgs");
var HxCreateCalendarItemResults_1 = require("./HxCreateCalendarItemResults");
var HxCreateCalendarSharingPermissionArgs_1 = require("./HxCreateCalendarSharingPermissionArgs");
var HxCreateCalendarSharingPermissionResults_1 = require("./HxCreateCalendarSharingPermissionResults");
var HxCreateCategoryArgs_1 = require("./HxCreateCategoryArgs");
var HxCreateContactResults_1 = require("./HxCreateContactResults");
var HxCreateDraftResults_1 = require("./HxCreateDraftResults");
var HxCreateErrorArgs_1 = require("./HxCreateErrorArgs");
var HxCreateExchangeConsumerAccountArgs_1 = require("./HxCreateExchangeConsumerAccountArgs");
var HxCreateFocusedInboxOverrideArgs_1 = require("./HxCreateFocusedInboxOverrideArgs");
var HxCreateICloudCcAccountArgs_1 = require("./HxCreateICloudCcAccountArgs");
var HxCreateInboxRuleResults_1 = require("./HxCreateInboxRuleResults");
var HxCreateManagedOnPremCcAccountArgs_1 = require("./HxCreateManagedOnPremCcAccountArgs");
var HxCreateMeetingReplyArgs_1 = require("./HxCreateMeetingReplyArgs");
var HxCreateMessageFromEMLArgs_1 = require("./HxCreateMessageFromEMLArgs");
var HxCreateMessageFromEMLResult_1 = require("./HxCreateMessageFromEMLResult");
var HxCreateNewDraftArgs_1 = require("./HxCreateNewDraftArgs");
var HxCreateO365AccountArgs_1 = require("./HxCreateO365AccountArgs");
var HxCreatePasswordBasedImapAccountArgs_1 = require("./HxCreatePasswordBasedImapAccountArgs");
var HxCreatePasswordBasedPopAccountArgs_1 = require("./HxCreatePasswordBasedPopAccountArgs");
var HxCreateReplyDraftArgs_1 = require("./HxCreateReplyDraftArgs");
var HxCreateScheduledViewArgs_1 = require("./HxCreateScheduledViewArgs");
var HxCreateSearchSessionResults_1 = require("./HxCreateSearchSessionResults");
var HxCreateSunriseAccountArgs_1 = require("./HxCreateSunriseAccountArgs");
var HxCreateToDoTaskFromMessageArgs_1 = require("./HxCreateToDoTaskFromMessageArgs");
var HxCreateToDoTaskFromMessageResults_1 = require("./HxCreateToDoTaskFromMessageResults");
var HxCreateTokenBasedImapAccountArgs_1 = require("./HxCreateTokenBasedImapAccountArgs");
var HxCreateUnmanagedOnPremCcAccountArgs_1 = require("./HxCreateUnmanagedOnPremCcAccountArgs");
var HxCreateViewArgs_1 = require("./HxCreateViewArgs");
var HxCreateViewResults_1 = require("./HxCreateViewResults");
var HxDefaultFetchArgs_1 = require("./HxDefaultFetchArgs");
var HxDeferredSendArgs_1 = require("./HxDeferredSendArgs");
var HxDeleteAvailabilityItemArgs_1 = require("./HxDeleteAvailabilityItemArgs");
var HxDeleteCalendarSharingPermissionArgs_1 = require("./HxDeleteCalendarSharingPermissionArgs");
var HxDeleteErrorArgs_1 = require("./HxDeleteErrorArgs");
var HxDeleteErrorsOfTypesArgs_1 = require("./HxDeleteErrorsOfTypesArgs");
var HxDeleteHolidayCalendarArgs_1 = require("./HxDeleteHolidayCalendarArgs");
var HxDeleteInferredLocationArgs_1 = require("./HxDeleteInferredLocationArgs");
var HxDeleteInternetHeadersOnMessageArgs_1 = require("./HxDeleteInternetHeadersOnMessageArgs");
var HxDeleteLocationSuggestionsItemArgs_1 = require("./HxDeleteLocationSuggestionsItemArgs");
var HxDeleteMailItemArgs_1 = require("./HxDeleteMailItemArgs");
var HxDeleteMeetingTimeSuggestionsItemArgs_1 = require("./HxDeleteMeetingTimeSuggestionsItemArgs");
var HxDeleteRoomListsItemArgs_1 = require("./HxDeleteRoomListsItemArgs");
var HxDeleteRoomsItemArgs_1 = require("./HxDeleteRoomsItemArgs");
var HxDeleteViewArgs_1 = require("./HxDeleteViewArgs");
var HxDismissReminderArgs_1 = require("./HxDismissReminderArgs");
var HxDoNotDisturbSettingsArgs_1 = require("./HxDoNotDisturbSettingsArgs");
var HxDownloadAttachmentsArgs_1 = require("./HxDownloadAttachmentsArgs");
var HxEmptyViewArgs_1 = require("./HxEmptyViewArgs");
var HxEnableWidgetDataArgs_1 = require("./HxEnableWidgetDataArgs");
var HxExpandDistributionListForSmimeDraftArgs_1 = require("./HxExpandDistributionListForSmimeDraftArgs");
var HxExportAppointmentToICSFileArgs_1 = require("./HxExportAppointmentToICSFileArgs");
var HxExportContactToVCFFileArgs_1 = require("./HxExportContactToVCFFileArgs");
var HxFailureResults_1 = require("./HxFailureResults");
var HxFetchAccessTokenForAddInArgs_1 = require("./HxFetchAccessTokenForAddInArgs");
var HxFetchAccessTokenForAddInResults_1 = require("./HxFetchAccessTokenForAddInResults");
var HxFetchAddInMarketplaceUrlResults_1 = require("./HxFetchAddInMarketplaceUrlResults");
var HxFetchAddInRoamingSettingsArgs_1 = require("./HxFetchAddInRoamingSettingsArgs");
var HxFetchAddInRoamingSettingsResults_1 = require("./HxFetchAddInRoamingSettingsResults");
var HxFetchAddInsResults_1 = require("./HxFetchAddInsResults");
var HxFetchAppointmentBodyArgs_1 = require("./HxFetchAppointmentBodyArgs");
var HxFetchAppointmentByDeviceIdArgs_1 = require("./HxFetchAppointmentByDeviceIdArgs");
var HxFetchAppointmentByDeviceIdResults_1 = require("./HxFetchAppointmentByDeviceIdResults");
var HxFetchAppointmentsArgs_1 = require("./HxFetchAppointmentsArgs");
var HxFetchAppointmentsResults_1 = require("./HxFetchAppointmentsResults");
var HxFetchAttachmentByServerIdArgs_1 = require("./HxFetchAttachmentByServerIdArgs");
var HxFetchAttachmentByServerIdResults_1 = require("./HxFetchAttachmentByServerIdResults");
var HxFetchAutoDetectArgs_1 = require("./HxFetchAutoDetectArgs");
var HxFetchAutoDetectResults_1 = require("./HxFetchAutoDetectResults");
var HxFetchAutoReplyConfigurationArgs_1 = require("./HxFetchAutoReplyConfigurationArgs");
var HxFetchAvailabilityArgs_1 = require("./HxFetchAvailabilityArgs");
var HxFetchAvailabilityResults_1 = require("./HxFetchAvailabilityResults");
var HxFetchCalendarFeedsArgs_1 = require("./HxFetchCalendarFeedsArgs");
var HxFetchCalendarSharingPermissionCollectionArgs_1 = require("./HxFetchCalendarSharingPermissionCollectionArgs");
var HxFetchCalendarSharingPermissionForRecipientArgs_1 = require("./HxFetchCalendarSharingPermissionForRecipientArgs");
var HxFetchCalendarSharingPermissionForRecipientResults_1 = require("./HxFetchCalendarSharingPermissionForRecipientResults");
var HxFetchCalendarViewArgs_1 = require("./HxFetchCalendarViewArgs");
var HxFetchCdnFilesArgs_1 = require("./HxFetchCdnFilesArgs");
var HxFetchCdnFilesResults_1 = require("./HxFetchCdnFilesResults");
var HxFetchContactByGraphIdArgs_1 = require("./HxFetchContactByGraphIdArgs");
var HxFetchContactByServerIdArgs_1 = require("./HxFetchContactByServerIdArgs");
var HxFetchContactResults_1 = require("./HxFetchContactResults");
var HxFetchCustomPropertiesOnAppointmentArgs_1 = require("./HxFetchCustomPropertiesOnAppointmentArgs");
var HxFetchCustomPropertiesOnMessageArgs_1 = require("./HxFetchCustomPropertiesOnMessageArgs");
var HxFetchCustomPropertiesResults_1 = require("./HxFetchCustomPropertiesResults");
var HxFetchDistributionListMembersArgs_1 = require("./HxFetchDistributionListMembersArgs");
var HxFetchDistributionListMembersResults_1 = require("./HxFetchDistributionListMembersResults");
var HxFetchEncryptionCertificatesArgs_1 = require("./HxFetchEncryptionCertificatesArgs");
var HxFetchHolidayCalendarCatalogArgs_1 = require("./HxFetchHolidayCalendarCatalogArgs");
var HxFetchInternetHeaderResults_1 = require("./HxFetchInternetHeaderResults");
var HxFetchInternetHeadersOnMessageArgs_1 = require("./HxFetchInternetHeadersOnMessageArgs");
var HxFetchIsHxSCapableArgs_1 = require("./HxFetchIsHxSCapableArgs");
var HxFetchIsHxSCapableResults_1 = require("./HxFetchIsHxSCapableResults");
var HxFetchLocalEventsArgs_1 = require("./HxFetchLocalEventsArgs");
var HxFetchLocationByEmailArgs_1 = require("./HxFetchLocationByEmailArgs");
var HxFetchLocationByEmailResults_1 = require("./HxFetchLocationByEmailResults");
var HxFetchLocationSuggestionsArgs_1 = require("./HxFetchLocationSuggestionsArgs");
var HxFetchMeetingTimeSuggestionsArgs_1 = require("./HxFetchMeetingTimeSuggestionsArgs");
var HxFetchMeetingTimeSuggestionsResults_1 = require("./HxFetchMeetingTimeSuggestionsResults");
var HxFetchMessageByServerIdArgs_1 = require("./HxFetchMessageByServerIdArgs");
var HxFetchMessageByServerIdResults_1 = require("./HxFetchMessageByServerIdResults");
var HxFetchMessagesArgs_1 = require("./HxFetchMessagesArgs");
var HxFetchMessagesForGroupCardArgs_1 = require("./HxFetchMessagesForGroupCardArgs");
var HxFetchMimeContentArgs_1 = require("./HxFetchMimeContentArgs");
var HxFetchMimeContentResults_1 = require("./HxFetchMimeContentResults");
var HxFetchMoreMessageHeadersArgs_1 = require("./HxFetchMoreMessageHeadersArgs");
var HxFetchMoreMessageHeadersResults_1 = require("./HxFetchMoreMessageHeadersResults");
var HxFetchPhotoArgs_1 = require("./HxFetchPhotoArgs");
var HxFetchPhotoResults_1 = require("./HxFetchPhotoResults");
var HxFetchRemoteMailboxSyncHealthResults_1 = require("./HxFetchRemoteMailboxSyncHealthResults");
var HxFetchRoomListsArgs_1 = require("./HxFetchRoomListsArgs");
var HxFetchRoomsArgs_1 = require("./HxFetchRoomsArgs");
var HxFetchSurfaceHubMeetingAttendeesResults_1 = require("./HxFetchSurfaceHubMeetingAttendeesResults");
var HxFetchToDoTasksFromMessageArgs_1 = require("./HxFetchToDoTasksFromMessageArgs");
var HxFetchUnreadCountForGroupsArgs_1 = require("./HxFetchUnreadCountForGroupsArgs");
var HxFetchWeatherArgs_1 = require("./HxFetchWeatherArgs");
var HxFetchWithContextArgs_1 = require("./HxFetchWithContextArgs");
var HxFilterContactsArgs_1 = require("./HxFilterContactsArgs");
var HxFindAttachmentsByPersonArgs_1 = require("./HxFindAttachmentsByPersonArgs");
var HxFindAttachmentsByPersonResults_1 = require("./HxFindAttachmentsByPersonResults");
var HxFindCalendarByDeviceIdArgs_1 = require("./HxFindCalendarByDeviceIdArgs");
var HxFindConflictingMeetingsArgs_1 = require("./HxFindConflictingMeetingsArgs");
var HxFindConflictingMeetingsResults_1 = require("./HxFindConflictingMeetingsResults");
var HxFindContactsBySearchStringArgs_1 = require("./HxFindContactsBySearchStringArgs");
var HxFindContactsBySearchStringResults_1 = require("./HxFindContactsBySearchStringResults");
var HxFindConversationsByPersonArgs_1 = require("./HxFindConversationsByPersonArgs");
var HxFindConversationsByPersonResults_1 = require("./HxFindConversationsByPersonResults");
var HxFindMeetingsByAttendeeArgs_1 = require("./HxFindMeetingsByAttendeeArgs");
var HxFindMeetingsByAttendeeResults_1 = require("./HxFindMeetingsByAttendeeResults");
var HxFlagMailItemArgs_1 = require("./HxFlagMailItemArgs");
var HxForwardCalendarEventArgs_1 = require("./HxForwardCalendarEventArgs");
var HxGetAppointmentExceptionResults_1 = require("./HxGetAppointmentExceptionResults");
var HxGetAppointmentForProtocolActivationArgs_1 = require("./HxGetAppointmentForProtocolActivationArgs");
var HxGetAppointmentForProtocolActivationByServerIdArgs_1 = require("./HxGetAppointmentForProtocolActivationByServerIdArgs");
var HxGetAppointmentForProtocolActivationResults_1 = require("./HxGetAppointmentForProtocolActivationResults");
var HxGetCertificateInfoForCertificatesArgs_1 = require("./HxGetCertificateInfoForCertificatesArgs");
var HxGetConversationIndexBasedOnSubstringOrDateTimeArgs_1 = require("./HxGetConversationIndexBasedOnSubstringOrDateTimeArgs");
var HxGetConversationIndexBasedOnSubstringOrDateTimeResults_1 = require("./HxGetConversationIndexBasedOnSubstringOrDateTimeResults");
var HxGetHexizedObjectIdsArgs_1 = require("./HxGetHexizedObjectIdsArgs");
var HxGetHexizedObjectIdsResults_1 = require("./HxGetHexizedObjectIdsResults");
var HxGetHexizedServerIdsArgs_1 = require("./HxGetHexizedServerIdsArgs");
var HxGetHexizedServerIdsResults_1 = require("./HxGetHexizedServerIdsResults");
var HxGetMessageHeaderForProtocolActivationArgs_1 = require("./HxGetMessageHeaderForProtocolActivationArgs");
var HxGetMessageHeaderForProtocolActivationResults_1 = require("./HxGetMessageHeaderForProtocolActivationResults");
var HxGetNextInstanceArgs_1 = require("./HxGetNextInstanceArgs");
var HxGetNextInstanceResults_1 = require("./HxGetNextInstanceResults");
var HxGetPreviousAndNextAppointmentInstancesResults_1 = require("./HxGetPreviousAndNextAppointmentInstancesResults");
var HxIgnoreConversationArgs_1 = require("./HxIgnoreConversationArgs");
var HxImportICSFileArgs_1 = require("./HxImportICSFileArgs");
var HxInboxRuleDataArgs_1 = require("./HxInboxRuleDataArgs");
var HxInstallAddInArgs_1 = require("./HxInstallAddInArgs");
var HxInstallAddInResults_1 = require("./HxInstallAddInResults");
var HxInstrumentCalendarSearchInteractionArgs_1 = require("./HxInstrumentCalendarSearchInteractionArgs");
var HxInstrumentMailSearchInteractionArgs_1 = require("./HxInstrumentMailSearchInteractionArgs");
var HxInstrumentPeopleSearchResultsDisplayedArgs_1 = require("./HxInstrumentPeopleSearchResultsDisplayedArgs");
var HxInstrumentSearchEventArgs_1 = require("./HxInstrumentSearchEventArgs");
var HxInstrumentSearchResultsDisplayedArgs_1 = require("./HxInstrumentSearchResultsDisplayedArgs");
var HxInstrumentSearchSubmittedExplicitlyArgs_1 = require("./HxInstrumentSearchSubmittedExplicitlyArgs");
var HxInstrumentSearchSuggestionActivatedArgs_1 = require("./HxInstrumentSearchSuggestionActivatedArgs");
var HxIsMessageSignerEncryptionCertificateInLocalCacheResults_1 = require("./HxIsMessageSignerEncryptionCertificateInLocalCacheResults");
var HxLocationSuggestionsResults_1 = require("./HxLocationSuggestionsResults");
var HxMarkAllActivitiesArgs_1 = require("./HxMarkAllActivitiesArgs");
var HxMarkAsReadAndArchiveByServerIdArgs_1 = require("./HxMarkAsReadAndArchiveByServerIdArgs");
var HxMarkAsReadAndDeleteMailArgs_1 = require("./HxMarkAsReadAndDeleteMailArgs");
var HxMarkMailItemAsJunkArgs_1 = require("./HxMarkMailItemAsJunkArgs");
var HxMarkMailItemAsPhishingArgs_1 = require("./HxMarkMailItemAsPhishingArgs");
var HxMarkMailItemReadArgs_1 = require("./HxMarkMailItemReadArgs");
var HxMarkOneRMContentViewedArgs_1 = require("./HxMarkOneRMContentViewedArgs");
var HxMeetingResponseArgs_1 = require("./HxMeetingResponseArgs");
var HxMockActionArgs_1 = require("./HxMockActionArgs");
var HxMockActionWithResultsArgs_1 = require("./HxMockActionWithResultsArgs");
var HxMockResults_1 = require("./HxMockResults");
var HxModuleIdentifierArgs_1 = require("./HxModuleIdentifierArgs");
var HxMoveFavoriteItemArgs_1 = require("./HxMoveFavoriteItemArgs");
var HxMoveFavoriteItemInUnifiedFavoritesArgs_1 = require("./HxMoveFavoriteItemInUnifiedFavoritesArgs");
var HxMoveMailItemArgs_1 = require("./HxMoveMailItemArgs");
var HxMoveToFocusedOtherArgs_1 = require("./HxMoveToFocusedOtherArgs");
var HxMoveToPreselectedArgs_1 = require("./HxMoveToPreselectedArgs");
var HxMoveViewArgs_1 = require("./HxMoveViewArgs");
var HxOnWatermarkPushNotificationArgs_1 = require("./HxOnWatermarkPushNotificationArgs");
var HxOnWatermarkPushNotificationResults_1 = require("./HxOnWatermarkPushNotificationResults");
var HxOpenICSFileArgs_1 = require("./HxOpenICSFileArgs");
var HxOpenICSFileResults_1 = require("./HxOpenICSFileResults");
var HxOpenVCFFileArgs_1 = require("./HxOpenVCFFileArgs");
var HxPinMailItemArgs_1 = require("./HxPinMailItemArgs");
var HxPresenceArgs_1 = require("./HxPresenceArgs");
var HxPresenceCacheResults_1 = require("./HxPresenceCacheResults");
var HxPreviewICSFileResults_1 = require("./HxPreviewICSFileResults");
var HxPreviewVCFFileResults_1 = require("./HxPreviewVCFFileResults");
var HxPrewarmSearchArgs_1 = require("./HxPrewarmSearchArgs");
var HxRecipientDataArgs_1 = require("./HxRecipientDataArgs");
var HxRemoveAtMentionsRecipientArgs_1 = require("./HxRemoveAtMentionsRecipientArgs");
var HxRemoveAttachmentFromAppointmentArgs_1 = require("./HxRemoveAttachmentFromAppointmentArgs");
var HxRemoveAttachmentFromDraftArgs_1 = require("./HxRemoveAttachmentFromDraftArgs");
var HxRemoveCachedRecipientArgs_1 = require("./HxRemoveCachedRecipientArgs");
var HxRemoveCalendarArgs_1 = require("./HxRemoveCalendarArgs");
var HxRemoveDelegatesArgs_1 = require("./HxRemoveDelegatesArgs");
var HxRenameViewArgs_1 = require("./HxRenameViewArgs");
var HxReParentDraftArgs_1 = require("./HxReParentDraftArgs");
var HxReportAbuseArgs_1 = require("./HxReportAbuseArgs");
var HxReportAutoDetectFeedbackArgs_1 = require("./HxReportAutoDetectFeedbackArgs");
var HxReportSearchFeedbackArgs_1 = require("./HxReportSearchFeedbackArgs");
var HxReportSearchFeedbackResults_1 = require("./HxReportSearchFeedbackResults");
var HxReportSearchInstrumentationArgs_1 = require("./HxReportSearchInstrumentationArgs");
var HxRequestSearchSuggestionsArgs_1 = require("./HxRequestSearchSuggestionsArgs");
var HxRequestSearchSuggestionsResults_1 = require("./HxRequestSearchSuggestionsResults");
var HxResolveAttachmentInlineStatusArgs_1 = require("./HxResolveAttachmentInlineStatusArgs");
var HxResolveLocalRecipientsArgs_1 = require("./HxResolveLocalRecipientsArgs");
var HxResolveLocalRecipientsResults_1 = require("./HxResolveLocalRecipientsResults");
var HxResolveSearchEntitiesArgs_1 = require("./HxResolveSearchEntitiesArgs");
var HxRespondToOneRMContentArgs_1 = require("./HxRespondToOneRMContentArgs");
var HxResumeHxCoreArgs_1 = require("./HxResumeHxCoreArgs");
var HxRetrieveCertificateInfoArgs_1 = require("./HxRetrieveCertificateInfoArgs");
var HxRetrieveCertificateInfoResults_1 = require("./HxRetrieveCertificateInfoResults");
var HxSaveAliasPreferenceArgs_1 = require("./HxSaveAliasPreferenceArgs");
var HxSaveAsEMLFileArgs_1 = require("./HxSaveAsEMLFileArgs");
var HxSaveBackgroundImageAnalysisResultArgs_1 = require("./HxSaveBackgroundImageAnalysisResultArgs");
var HxSaveDraftArgs_1 = require("./HxSaveDraftArgs");
var HxSaveDraftResults_1 = require("./HxSaveDraftResults");
var HxSaveGlobalApplicationApplyAllPreferencesArgs_1 = require("./HxSaveGlobalApplicationApplyAllPreferencesArgs");
var HxSaveGlobalApplicationDaysToPrescheduleRemindersArgs_1 = require("./HxSaveGlobalApplicationDaysToPrescheduleRemindersArgs");
var HxSaveGlobalApplicationDefaultFontPreferencesArgs_1 = require("./HxSaveGlobalApplicationDefaultFontPreferencesArgs");
var HxSaveGlobalApplicationExternalContentPreferencesArgs_1 = require("./HxSaveGlobalApplicationExternalContentPreferencesArgs");
var HxSaveGlobalApplicationMarkAsReadSettingArgs_1 = require("./HxSaveGlobalApplicationMarkAsReadSettingArgs");
var HxSaveGlobalApplicationPersonalizationSettingsArgs_1 = require("./HxSaveGlobalApplicationPersonalizationSettingsArgs");
var HxSaveGlobalApplicationQuickActionsPreferencesArgs_1 = require("./HxSaveGlobalApplicationQuickActionsPreferencesArgs");
var HxSaveGlobalApplicationSettingByPropertyIDArgs_1 = require("./HxSaveGlobalApplicationSettingByPropertyIDArgs");
var HxSaveGlobalApplicationSignaturePreferencesArgs_1 = require("./HxSaveGlobalApplicationSignaturePreferencesArgs");
var HxSaveGlobalApplicationTimeZoneIdArgs_1 = require("./HxSaveGlobalApplicationTimeZoneIdArgs");
var HxScheduleMailItemArgs_1 = require("./HxScheduleMailItemArgs");
var HxSearchAnswersArgs_1 = require("./HxSearchAnswersArgs");
var HxSearchAttachmentsArgs_1 = require("./HxSearchAttachmentsArgs");
var HxSearchCalendarArgs_1 = require("./HxSearchCalendarArgs");
var HxSearchCalendarLegacyArgs_1 = require("./HxSearchCalendarLegacyArgs");
var HxSearchCalendarLegacyResults_1 = require("./HxSearchCalendarLegacyResults");
var HxSearchContactsArgs_1 = require("./HxSearchContactsArgs");
var HxSearchContactsResults_1 = require("./HxSearchContactsResults");
var HxSearchFilesArgs_1 = require("./HxSearchFilesArgs");
var HxSearchForMessageHeadersInConversationArgs_1 = require("./HxSearchForMessageHeadersInConversationArgs");
var HxSearchLocalContactsArgs_1 = require("./HxSearchLocalContactsArgs");
var HxSearchLocalContactsResults_1 = require("./HxSearchLocalContactsResults");
var HxSearchMailArgs_1 = require("./HxSearchMailArgs");
var HxSearchMailResults_1 = require("./HxSearchMailResults");
var HxSearchNextPageArgs_1 = require("./HxSearchNextPageArgs");
var HxSearchPeopleArgs_1 = require("./HxSearchPeopleArgs");
var HxSearchPeopleForAddressingArgs_1 = require("./HxSearchPeopleForAddressingArgs");
var HxSearchPeopleForAddressingResults_1 = require("./HxSearchPeopleForAddressingResults");
var HxSearchRecentAttachmentsArgs_1 = require("./HxSearchRecentAttachmentsArgs");
var HxSearchRecipientByKeystrokeArgs_1 = require("./HxSearchRecipientByKeystrokeArgs");
var HxSearchTopArgs_1 = require("./HxSearchTopArgs");
var HxSearchTopNextPageArgs_1 = require("./HxSearchTopNextPageArgs");
var HxSetAccountCertificateOrderListArgs_1 = require("./HxSetAccountCertificateOrderListArgs");
var HxSetAccountLDAPServerSettingListArgs_1 = require("./HxSetAccountLDAPServerSettingListArgs");
var HxSetAccountPreferenceArgs_1 = require("./HxSetAccountPreferenceArgs");
var HxSetAddInRoamingSettingsArgs_1 = require("./HxSetAddInRoamingSettingsArgs");
var HxSetBadgeCountPushNotificationInfoArgs_1 = require("./HxSetBadgeCountPushNotificationInfoArgs");
var HxSetCalendarDefaultReminderTimeArgs_1 = require("./HxSetCalendarDefaultReminderTimeArgs");
var HxSetConversationViewModeArgs_1 = require("./HxSetConversationViewModeArgs");
var HxSetCustomPropertiesOnItemArgs_1 = require("./HxSetCustomPropertiesOnItemArgs");
var HxSetDefaultFontHtmlArgs_1 = require("./HxSetDefaultFontHtmlArgs");
var HxSetDraftPriorityArgs_1 = require("./HxSetDraftPriorityArgs");
var HxSetDraftSenderEmailArgs_1 = require("./HxSetDraftSenderEmailArgs");
var HxSetEncryptingAlgorithmArgs_1 = require("./HxSetEncryptingAlgorithmArgs");
var HxSetEncryptingCertificateHashArgs_1 = require("./HxSetEncryptingCertificateHashArgs");
var HxSetFirstBodyByteOffsetArgs_1 = require("./HxSetFirstBodyByteOffsetArgs");
var HxSetFirstDayOfWeekArgs_1 = require("./HxSetFirstDayOfWeekArgs");
var HxSetInternetHeadersOnMessageArgs_1 = require("./HxSetInternetHeadersOnMessageArgs");
var HxSetIsDraftEncryptedArgs_1 = require("./HxSetIsDraftEncryptedArgs");
var HxSetIsDraftSignedArgs_1 = require("./HxSetIsDraftSignedArgs");
var HxSetIsDraftSmimeResults_1 = require("./HxSetIsDraftSmimeResults");
var HxSetIsFocusedInboxEnabledArgs_1 = require("./HxSetIsFocusedInboxEnabledArgs");
var HxSetMessageClassificationArgs_1 = require("./HxSetMessageClassificationArgs");
var HxSetMipLabelArgs_1 = require("./HxSetMipLabelArgs");
var HxSetOnlineMeetingsByDefaultEnabledArgs_1 = require("./HxSetOnlineMeetingsByDefaultEnabledArgs");
var HxSetPreselectedMoveToViewsPrimaryArgs_1 = require("./HxSetPreselectedMoveToViewsPrimaryArgs");
var HxSetPreselectedMoveToViewsSecondaryArgs_1 = require("./HxSetPreselectedMoveToViewsSecondaryArgs");
var HxSetPushNotificationSettingsArgs_1 = require("./HxSetPushNotificationSettingsArgs");
var HxSetPushNotificationTokenArgs_1 = require("./HxSetPushNotificationTokenArgs");
var HxSetQuickActionPrimaryArgs_1 = require("./HxSetQuickActionPrimaryArgs");
var HxSetQuickActionSecondaryArgs_1 = require("./HxSetQuickActionSecondaryArgs");
var HxSetRecipientsArgs_1 = require("./HxSetRecipientsArgs");
var HxSetRecipientsResults_1 = require("./HxSetRecipientsResults");
var HxSetReminderTimeForCloudCacheDialogArgs_1 = require("./HxSetReminderTimeForCloudCacheDialogArgs");
var HxSetSignatureHtmlArgs_1 = require("./HxSetSignatureHtmlArgs");
var HxSetSigningAlgorithmArgs_1 = require("./HxSetSigningAlgorithmArgs");
var HxSetSigningCertificateHashArgs_1 = require("./HxSetSigningCertificateHashArgs");
var HxSetSpeedyMeetingSettingArgs_1 = require("./HxSetSpeedyMeetingSettingArgs");
var HxSetTeachingStatusArgs_1 = require("./HxSetTeachingStatusArgs");
var HxSetViewSortModeArgs_1 = require("./HxSetViewSortModeArgs");
var HxSetWeekNumberSettingArgs_1 = require("./HxSetWeekNumberSettingArgs");
var HxSimulatedWatermarkPushNotificationArgs_1 = require("./HxSimulatedWatermarkPushNotificationArgs");
var HxSimulatedWatermarkPushNotificationResults_1 = require("./HxSimulatedWatermarkPushNotificationResults");
var HxSnoozeReminderArgs_1 = require("./HxSnoozeReminderArgs");
var HxSortContactsArgs_1 = require("./HxSortContactsArgs");
var HxStringArgs_1 = require("./HxStringArgs");
var HxTileIdArgs_1 = require("./HxTileIdArgs");
var HxTurnOnAutoReplyArgs_1 = require("./HxTurnOnAutoReplyArgs");
var HxUnsubscribeFromMailingListArgs_1 = require("./HxUnsubscribeFromMailingListArgs");
var HxUpdateAccountArgs_1 = require("./HxUpdateAccountArgs");
var HxUpdateAccountCredentialsArgs_1 = require("./HxUpdateAccountCredentialsArgs");
var HxUpdateAccountCredentialsResults_1 = require("./HxUpdateAccountCredentialsResults");
var HxUpdateAccountResults_1 = require("./HxUpdateAccountResults");
var HxUpdateBatteryStatusArgs_1 = require("./HxUpdateBatteryStatusArgs");
var HxUpdateCalendarArgs_1 = require("./HxUpdateCalendarArgs");
var HxUpdateCalendarItemArgs_1 = require("./HxUpdateCalendarItemArgs");
var HxUpdateCalendarSharingPermissionArgs_1 = require("./HxUpdateCalendarSharingPermissionArgs");
var HxUpdateCategoryColorArgs_1 = require("./HxUpdateCategoryColorArgs");
var HxUpdateContactDisplayNameSettingArgs_1 = require("./HxUpdateContactDisplayNameSettingArgs");
var HxUpdateDelegatesArgs_1 = require("./HxUpdateDelegatesArgs");
var HxUpdateDesiredCdnFilesArgs_1 = require("./HxUpdateDesiredCdnFilesArgs");
var HxUpdateDeviceLocationArgs_1 = require("./HxUpdateDeviceLocationArgs");
var HxUpdateGroupArgs_1 = require("./HxUpdateGroupArgs");
var HxUpdateInlineAttachmentToDraftArgs_1 = require("./HxUpdateInlineAttachmentToDraftArgs");
var HxUpdateInlineAttachmentToDraftResults_1 = require("./HxUpdateInlineAttachmentToDraftResults");
var HxUpdateIRMToDraftArgs_1 = require("./HxUpdateIRMToDraftArgs");
var HxUpdateNetworkStatusArgs_1 = require("./HxUpdateNetworkStatusArgs");
var HxUpdatePolicyComplianceArgs_1 = require("./HxUpdatePolicyComplianceArgs");
var HxUpdateReactionArgs_1 = require("./HxUpdateReactionArgs");
var HxUpdateTeachingTriggerArgs_1 = require("./HxUpdateTeachingTriggerArgs");
var HxUpdateToDoTaskArgs_1 = require("./HxUpdateToDoTaskArgs");
var HxUpdateWeatherSettingsArgs_1 = require("./HxUpdateWeatherSettingsArgs");
var HxValidateCertificatesArgs_1 = require("./HxValidateCertificatesArgs");
var HxValidateRecipientEncryptionCertificatesArgs_1 = require("./HxValidateRecipientEncryptionCertificatesArgs");
var HxValidateUserSmimeCertificatesArgs_1 = require("./HxValidateUserSmimeCertificatesArgs");
var HxViewSwitchedArgs_1 = require("./HxViewSwitchedArgs");
var HxActorAPIs = /** @class */ (function () {
    function HxActorAPIs(nativeInterop, globalCounterSeed, processIdentifier) {
        this._nativeInterop = nativeInterop;
        this.globalCounterSeed = globalCounterSeed;
        this.processIdentifier = processIdentifier;
    }
    HxActorAPIs.prototype.undo = function (requestId) {
        var requestIdForRedo = this.createRequestId();
        this._nativeInterop.undoAction(requestId, requestIdForRedo);
        return requestIdForRedo;
    };
    HxActorAPIs.prototype.dismissUndo = function (requestId) {
        this._nativeInterop.dismissUndo(requestId);
    };
    HxActorAPIs.prototype.dismissAllUndo = function () {
        this._nativeInterop.dismissAllUndo();
    };
    /**
    * AddAtMentionRecipient
    * @param recipientType Specifies which collection (i.e., To, Cc, or Bcc) this recipient will be added to
    */
    HxActorAPIs.prototype.addAtMentionRecipient = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in AddAtMentionRecipient. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxAddRecipientArgs_1.serializeHxAddRecipientArgs(args);
        return this.runActorWithResultsAsync(570, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addAttachmentFileToAppointment = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in AddAttachmentFileToAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxAddAttachmentFileToDraftArgs_1.serializeHxAddAttachmentFileToDraftArgs(args);
        return this.runActorWithResultsAsync(357, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addAttachmentFileToDraft = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in AddAttachmentFileToDraft. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxAddAttachmentFileToDraftArgs_1.serializeHxAddAttachmentFileToDraftArgs(args);
        return this.runActorWithResultsAsync(9, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addBlockedSenderAndDomain = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddBlockedSenderAndDomain. Expected Types: HxAccount");
        }
        var serialized_args = HxAddBlockedSenderAndDomainArgs_1.serializeHxAddBlockedSenderAndDomainArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(641, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.addBlockedSenderAndDomainWithUndo = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddBlockedSenderAndDomain. Expected Types: HxAccount");
        }
        var serialized_args = HxAddBlockedSenderAndDomainArgs_1.serializeHxAddBlockedSenderAndDomainArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(641, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.addDelegates = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddDelegates. Expected Types: HxAccount");
        }
        var serialized_args = HxAddDelegatesArgs_1.serializeHxAddDelegatesArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(667, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.addFavoriteGroup = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxGroup) {
            throw new Error("Incorrect object type for target in AddFavoriteGroup. Expected Types: HxGroup");
        }
        var serialized_args = [];
        return this.runActorWithResultsAsync(473, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addFavoriteGroupWithUndo = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxGroup) {
            throw new Error("Incorrect object type for target in AddFavoriteGroup. Expected Types: HxGroup");
        }
        var serialized_args = [];
        return this.runActorWithResultsAsync(473, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, true /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addFavoritePerson = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddFavoritePerson. Expected Types: HxAccount");
        }
        var serialized_args = HxAddFavoritePersonArgs_1.serializeHxAddFavoritePersonArgs(args);
        return this.runActorWithResultsAsync(474, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addFavoritePersonWithUndo = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddFavoritePerson. Expected Types: HxAccount");
        }
        var serialized_args = HxAddFavoritePersonArgs_1.serializeHxAddFavoritePersonArgs(args);
        return this.runActorWithResultsAsync(474, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, true /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addFavoriteView = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in AddFavoriteView. Expected Types: HxView");
        }
        var serialized_args = [];
        return this.runActorWithResultsAsync(475, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addFavoriteViewWithUndo = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in AddFavoriteView. Expected Types: HxView");
        }
        var serialized_args = [];
        return this.runActorWithResultsAsync(475, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, true /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addFeedSubscription = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddFeedSubscription. Expected Types: HxAccount");
        }
        var serialized_args = HxAddFeedSubscriptionArgs_1.serializeHxAddFeedSubscriptionArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(178, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * AddGroupEventToCalendar: Requires ImmutableIds for the Appointment to be added.
    */
    HxActorAPIs.prototype.addGroupEventToCalendar = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in AddGroupEventToCalendar. Expected Types: HxMessageHeader");
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(569, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.addHolidayCalendar = function (args, actorCompletionNotificationType) {
        var serialized_args = HxAddHolidayCalendarArgs_1.serializeHxAddHolidayCalendarArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(199, [], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.addMessageSignerEncryptionCertificateToLocalCache = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in AddMessageSignerEncryptionCertificateToLocalCache. Expected Types: HxMessageHeader");
        }
        return this.runActor(586, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.addPresenceObservers = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddPresenceObservers. Expected Types: HxAccount");
        }
        var serialized_args = HxPresenceArgs_1.serializeHxPresenceArgs(args);
        return this.runActorWithResultsAsync(634, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * AddRecipient
    * @param recipientType Specifies which collection (i.e., To, Cc, or Bcc) this recipient will be added to
    */
    HxActorAPIs.prototype.addRecipient = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in AddRecipient. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxAddRecipientArgs_1.serializeHxAddRecipientArgs(args);
        return this.runActorWithResultsAsync(222, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.addSharedCalendar = function (targetId, actorCompletionNotificationType) {
        if (!targetId[0].isNil() && targetId[0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for first item of the Pair Target in AddSharedCalendar. Expected ConversationHeader");
        }
        if (!targetId[1].isNil() && targetId[1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for second item of the Pair Target in AddSharedCalendar. Expected MessageHeader");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(280, [targetId], '[]', completionNotificationType);
    };
    /**
    * AddSharedCalendarBySmtp
    * @param calendarName Specifies a calendar name to use as the display name. If none is specified the server will provide either a name or email address as the default calendar name.
    */
    HxActorAPIs.prototype.addSharedCalendarBySmtp = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in AddSharedCalendarBySmtp. Expected Types: HxAccount");
        }
        var serialized_args = HxAddSharedCalendarBySmtpArgs_1.serializeHxAddSharedCalendarBySmtpArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(619, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.addTailoredEventsToCalendar = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in AddTailoredEventsToCalendar. Expected Types: HxMessageHeader");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(262, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.allowUserDataNetworkConnections = function () {
        return this.runActor(637, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.archiveMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in ArchiveMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in ArchiveMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxArchiveMailItemArgs_1.serializeHxArchiveMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(141, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.archiveMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in ArchiveMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in ArchiveMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxArchiveMailItemArgs_1.serializeHxArchiveMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(141, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.archiveMailItemByServerId = function (targetIds, args, actorCompletionNotificationType) {
        var serialized_args = HxArchiveMailItemArgs_1.serializeHxArchiveMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(405, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.blockMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in BlockMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in BlockMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxDeleteMailItemArgs_1.serializeHxDeleteMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(805, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.blockMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in BlockMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in BlockMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxDeleteMailItemArgs_1.serializeHxDeleteMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(805, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * CallGenericRestApi: Sends an HTTP request to the specified URL and returns the response in the results
    * @param requestUrl The full path of the request URL, including any query params.
    * @param requestMethod The request method as defined in the HTTP standard. Could be GET, HEAD, POST, etc.
    * @param requestHeaders A list of pairs of strings, with the HTTP headers for this request.
    * @param requestBody The body bytes of the request.
    * @param commandName The name of the command in this request. This is important for telemetry purposes, so we can track which actions are being taken via REST.
    * @param token The token to access the API, if any is needed.
    */
    HxActorAPIs.prototype.callGenericRestApi = function (args) {
        var serialized_args = HxCallGenericRestApiArgs_1.serializeHxCallGenericRestApiArgs(args);
        return this.runActorWithResultsAsync(751, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * CallOutlookRestApi: Sends an HTTP request to the specified REST endpoint and returns the response in the results.
    * @param endpoint The endpoint of this request, which could be Addins, Graph, Outlook or Substrate.
    * @param cloudEnvironment The cloud environment of the account, used to figure out the endpoint URL for sovereign clouds.
    * @param relativePath The relative path to the endpoint of the request, including any query params.
    * @param requestMethod The request method as defined in the HTTP standard. Could be GET, HEAD, POST, etc.
    * @param requestHeaders A list of pairs of strings, with the HTTP headers for this request.
    * @param requestBody The body bytes of the request.
    * @param commandName The name of the command in this request. This is important for telemetry purposes, so we can track which actions are being taken via REST.
    * @param token The token to access the REST API. If not provided, the default token will be used.
    */
    HxActorAPIs.prototype.callOutlookRestApi = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CallOutlookRestApi. Expected Types: HxAccount");
        }
        var serialized_args = HxCallOutlookRestApiArgs_1.serializeHxCallOutlookRestApiArgs(args);
        return this.runActorWithResultsAsync(745, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * CancelCalendarEvent
    * @param subject Localized string to use for cancelation email title for DirectSync. If not populated, meeting title will be used.
    */
    HxActorAPIs.prototype.cancelCalendarEvent = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in CancelCalendarEvent. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxCancelCalendarEventArgs_1.serializeHxCancelCalendarEventArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(63, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.cancelDeferredSend = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in CancelDeferredSend. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(601, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.cancelDownloadAttachments = function (targetIds) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAttachmentHeader) {
                throw new Error("Incorrect object type for target in CancelDownloadAttachments. Expected Types: HxAttachmentHeader");
            }
        }
        return this.runActor(354, targetIds, '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.cancelSend = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in CancelSend. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(607, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.categorizeMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in CategorizeMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in CategorizeMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxCategorizeMailItemArgs_1.serializeHxCategorizeMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(480, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.categorizeMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in CategorizeMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in CategorizeMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxCategorizeMailItemArgs_1.serializeHxCategorizeMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(480, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.clearAppointmentPreservers = function () {
        return this.runActor(359, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.clearMipLabel = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in ClearMipLabel. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxClearMipLabelArgs_1.serializeHxClearMipLabelArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(555, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.clearSearchSuggestions = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in ClearSearchSuggestions. Expected Types: HxSearchSession");
        }
        return this.runActor(289, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.clearUnseenFocusOtherNotifications = function (args) {
        var serialized_args = HxClearUnseenFocusOtherNotificationsArgs_1.serializeHxClearUnseenFocusOtherNotificationsArgs(args);
        return this.runActor(286, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeAnswersSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in CloseAnswersSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxCloseAnswersSearchArgs_1.serializeHxCloseAnswersSearchArgs(args);
        return this.runActor(718, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeAttachmentSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in CloseAttachmentSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxCloseAttachmentSearchArgs_1.serializeHxCloseAttachmentSearchArgs(args);
        return this.runActor(437, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeCalendarSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in CloseCalendarSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxCloseCalendarSearchArgs_1.serializeHxCloseCalendarSearchArgs(args);
        return this.runActor(338, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeCalendarSearchLegacy = function () {
        return this.runActor(614, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeFilesSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in CloseFilesSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxCloseFilesSearchArgs_1.serializeHxCloseFilesSearchArgs(args);
        return this.runActor(780, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeICSFile = function (args) {
        var serialized_args = HxCloseICSFileArgs_1.serializeHxCloseICSFileArgs(args);
        return this.runActor(744, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeMailSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in CloseMailSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxCloseMailSearchArgs_1.serializeHxCloseMailSearchArgs(args);
        return this.runActor(337, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closePeopleSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in ClosePeopleSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxClosePeopleSearchArgs_1.serializeHxClosePeopleSearchArgs(args);
        return this.runActor(664, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeRecipientSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in CloseRecipientSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxCloseRecipientSearchArgs_1.serializeHxCloseRecipientSearchArgs(args);
        return this.runActor(776, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeTopSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in CloseTopSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxCloseTopSearchArgs_1.serializeHxCloseTopSearchArgs(args);
        return this.runActor(716, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.closeVCFFile = function (args) {
        var serialized_args = HxCloseVCFFileArgs_1.serializeHxCloseVCFFileArgs(args);
        return this.runActor(793, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.copyMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in CopyMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in CopyMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxCopyMailItemArgs_1.serializeHxCopyMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(299, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.copyMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in CopyMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in CopyMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxCopyMailItemArgs_1.serializeHxCopyMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(299, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * CreateAccount
    * @param incomingServerPort For DirectSync; IMAP/POP server port. If set 0, createAccount actor will fail with precondition violated
    * @param outgoingServerAddress For DirectSync; smtp server
    * @param outgoingServerPort For DirectSync; smtp port. Must be a non-zero port value, otherwise createAccount actor will fail with precondition violated
    * @param outgoingServerSslScheme For DirectSync; SMTP server setting
    * @param onPremisePortForCloudCache Use this to provide a custom port for On Premise URI. Pass NULL for default port.
    * @param popLeaveOnServer for pop accounts only; false: messages are deleted after downloading them from server, true: messages are left in the server, ignored/not-used on non-pop accounts
    * @param cloudEnvironmentForAAD AAD accounts (M-OPCC and O365) needs to be double checked for where it is hosted
    * @param sslCertificateValidation for directsync/imapcc/mopcc/uopcc accounts only; Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.createAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateAccountArgs_1.serializeHxCreateAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(154, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(154, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(154, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createArchiveView = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateArchiveView. Expected Types: HxAccount");
        }
        var serialized_args = HxStringArgs_1.serializeHxStringArgs(args);
        return this.runActorWithResultsAsync(694, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * CreateCalendar
    * @param parentGroupId Identifier for the parent group
    */
    HxActorAPIs.prototype.createCalendar = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateCalendar. Expected Types: HxAccount");
        }
        var serialized_args = HxCreateCalendarArgs_1.serializeHxCreateCalendarArgs(args);
        return this.runActorWithResultsAsync(672, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createCalendarItem = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in CreateCalendarItem. Expected Types: HxCalendarData");
        }
        var serialized_args = HxCreateCalendarItemArgs_1.serializeHxCreateCalendarItemArgs(args);
        return this.runActorWithResultsAsync(64, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createCalendarItemDraftWithAttendees = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in CreateCalendarItemDraftWithAttendees. Expected Types: HxCalendarData");
        }
        var serialized_args = HxCreateCalendarItemArgs_1.serializeHxCreateCalendarItemArgs(args);
        return this.runActorWithResultsAsync(725, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createCalendarSharingPermission = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in CreateCalendarSharingPermission. Expected Types: HxCalendarData");
        }
        var serialized_args = HxCreateCalendarSharingPermissionArgs_1.serializeHxCreateCalendarSharingPermissionArgs(args);
        return this.runActorWithResultsAsync(317, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createCategory = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateCategory. Expected Types: HxAccount");
        }
        var serialized_args = HxCreateCategoryArgs_1.serializeHxCreateCategoryArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(481, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * CreateContact
    * @param hasRemoteId Whether or not ContactsRT contact has a RemoteId set. Only true when reading a contact update.
    * @param importantDates Important dates such as birthdays, anniversaries and other custom values. UTC DateTime property must not contain any time component.
    */
    HxActorAPIs.prototype.createContact = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateContact. Expected Types: HxAccount");
        }
        var serialized_args = HxContactArgs_1.serializeHxContactArgs(args);
        return this.runActorWithResultsAsync(250, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createError = function (args) {
        var serialized_args = HxCreateErrorArgs_1.serializeHxCreateErrorArgs(args);
        return this.runActor(27, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.createFocusedInboxOverride = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in CreateFocusedInboxOverride. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in CreateFocusedInboxOverride. Expected MessageHeader");
            }
        }
        var serialized_args = HxCreateFocusedInboxOverrideArgs_1.serializeHxCreateFocusedInboxOverrideArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(261, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.createGoogleCcAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateExchangeConsumerAccountArgs_1.serializeHxCreateExchangeConsumerAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(752, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(752, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(752, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createGoogleImapAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateTokenBasedImapAccountArgs_1.serializeHxCreateTokenBasedImapAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(754, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(754, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(754, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createICloudCcAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateICloudCcAccountArgs_1.serializeHxCreateICloudCcAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(756, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(756, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(756, JSON.parse(failureresults))); }); });
    };
    /**
    * CreateICloudImapAccount
    * @param sslCertificateValidation Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.createICloudImapAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreatePasswordBasedImapAccountArgs_1.serializeHxCreatePasswordBasedImapAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(773, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(773, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(773, JSON.parse(failureresults))); }); });
    };
    /**
    * CreateImapAccount
    * @param sslCertificateValidation Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.createImapAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreatePasswordBasedImapAccountArgs_1.serializeHxCreatePasswordBasedImapAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(757, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(757, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(757, JSON.parse(failureresults))); }); });
    };
    /**
    * CreateImapCcAccount
    * @param sslCertificateValidation Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.createImapCcAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreatePasswordBasedImapAccountArgs_1.serializeHxCreatePasswordBasedImapAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(758, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(758, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(758, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createInboxRule = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateInboxRule. Expected Types: HxAccount");
        }
        var serialized_args = HxInboxRuleDataArgs_1.serializeHxInboxRuleDataArgs(args);
        return this.runActorWithResultsAsync(330, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * CreateManagedOnPremCcAccount
    * @param cloudEnvironmentForAAD AAD accounts (M-OPCC and O365) needs to be double checked for where it is hosted
    * @param sslCertificateValidation Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.createManagedOnPremCcAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateManagedOnPremCcAccountArgs_1.serializeHxCreateManagedOnPremCcAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(761, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(761, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(761, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createMessageFromEML = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in CreateMessageFromEML. Expected Types: HxView");
        }
        var serialized_args = HxCreateMessageFromEMLArgs_1.serializeHxCreateMessageFromEMLArgs(args);
        return this.runActorWithResultsAsync(814, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createMessageFromEMLWithUndo = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in CreateMessageFromEML. Expected Types: HxView");
        }
        var serialized_args = HxCreateMessageFromEMLArgs_1.serializeHxCreateMessageFromEMLArgs(args);
        return this.runActorWithResultsAsync(814, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, true /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createMsaAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateExchangeConsumerAccountArgs_1.serializeHxCreateExchangeConsumerAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(740, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(740, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(740, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createNewDraft = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateNewDraft. Expected Types: HxAccount");
        }
        var serialized_args = HxCreateNewDraftArgs_1.serializeHxCreateNewDraftArgs(args);
        return this.runActorWithResultsAsync(373, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * CreateO365Account
    * @param cloudEnvironmentForAAD AAD accounts (M-OPCC and O365) needs to be double checked for where it is hosted
    */
    HxActorAPIs.prototype.createO365Account = function (args) {
        var _this = this;
        var serialized_args = HxCreateO365AccountArgs_1.serializeHxCreateO365AccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(739, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(739, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(739, JSON.parse(failureresults))); }); });
    };
    /**
    * CreatePopAccount
    * @param sslCertificateValidation Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    * @param popLeaveOnServer false: messages are deleted after downloading them from server, true: messages are left in the server
    */
    HxActorAPIs.prototype.createPopAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreatePasswordBasedPopAccountArgs_1.serializeHxCreatePasswordBasedPopAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(759, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(759, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(759, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createScheduledView = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateScheduledView. Expected Types: HxAccount");
        }
        var serialized_args = HxCreateScheduledViewArgs_1.serializeHxCreateScheduledViewArgs(args);
        return this.runActorWithResultsAsync(455, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createSearchSession = function () {
        return this.runActorWithResultsAsync(595, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createSunriseAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateSunriseAccountArgs_1.serializeHxCreateSunriseAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(737, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(737, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(737, JSON.parse(failureresults))); }); });
    };
    /**
    * CreateToDoTaskFromMessage
    * @param dueDate If this value isn't passed there will be no default from ToDo, so it will remain INVALID.
    */
    HxActorAPIs.prototype.createToDoTaskFromMessage = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in CreateToDoTaskFromMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxCreateToDoTaskFromMessageArgs_1.serializeHxCreateToDoTaskFromMessageArgs(args);
        return this.runActorWithResultsAsync(766, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * CreateUnmanagedOnPremCcAccount
    * @param sslCertificateValidation Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.createUnmanagedOnPremCcAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateUnmanagedOnPremCcAccountArgs_1.serializeHxCreateUnmanagedOnPremCcAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(762, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(762, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(762, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createView = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in CreateView. Expected Types: HxAccount");
        }
        var serialized_args = HxCreateViewArgs_1.serializeHxCreateViewArgs(args);
        return this.runActorWithResultsAsync(31, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.createYahooCcAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateExchangeConsumerAccountArgs_1.serializeHxCreateExchangeConsumerAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(753, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(753, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(753, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.createYahooImapAccount = function (args) {
        var _this = this;
        var serialized_args = HxCreateTokenBasedImapAccountArgs_1.serializeHxCreateTokenBasedImapAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(755, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(755, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(755, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.deferredSend = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in DeferredSend. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxDeferredSendArgs_1.serializeHxDeferredSendArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(600, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteAllAvailabilityItems = function () {
        return this.runActor(76, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteAllLocationSuggestionsItems = function () {
        return this.runActor(247, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteAllMeetingTimeSuggestions = function () {
        return this.runActor(321, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteAllRoomListsItems = function () {
        return this.runActor(79, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteAllRoomsItems = function () {
        return this.runActor(82, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteAvailabilityItem = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in DeleteAvailabilityItem. Expected Types: HxAccount");
        }
        var serialized_args = HxDeleteAvailabilityItemArgs_1.serializeHxDeleteAvailabilityItemArgs(args);
        return this.runActor(77, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteCalendarEvent = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in DeleteCalendarEvent. Expected Types: HxAppointmentHeader");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(65, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.deleteCalendarItemThisAndForward = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in DeleteCalendarItemThisAndForward. Expected Types: HxAppointmentHeader");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(804, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.deleteCalendarSharingPermission = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in DeleteCalendarSharingPermission. Expected Types: HxCalendarData");
        }
        var serialized_args = HxDeleteCalendarSharingPermissionArgs_1.serializeHxDeleteCalendarSharingPermissionArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(319, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteCategory = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxCategoryData) {
                throw new Error("Incorrect object type for target in DeleteCategory. Expected Types: HxCategoryData");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(491, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.deleteContact = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxContact) {
            throw new Error("Incorrect object type for target in DeleteContact. Expected Types: HxContact");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(252, [targetId], '[]', completionNotificationType);
    };
    /**
    * DeleteError: Removes the Error object referenced in the Args
    */
    HxActorAPIs.prototype.deleteError = function (args) {
        var serialized_args = HxDeleteErrorArgs_1.serializeHxDeleteErrorArgs(args);
        return this.runActor(28, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteErrorsOfTypes = function (args) {
        var serialized_args = HxDeleteErrorsOfTypesArgs_1.serializeHxDeleteErrorsOfTypesArgs(args);
        return this.runActor(237, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteGroup = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxGroup) {
            throw new Error("Incorrect object type for target in DeleteGroup. Expected Types: HxGroup");
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(564, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteHolidayCalendar = function (args, actorCompletionNotificationType) {
        var serialized_args = HxDeleteHolidayCalendarArgs_1.serializeHxDeleteHolidayCalendarArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(200, [], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteInboxRule = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxInboxRule) {
            throw new Error("Incorrect object type for target in DeleteInboxRule. Expected Types: HxInboxRule");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(332, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.deleteInferredLocation = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in DeleteInferredLocation. Expected Types: HxAccount");
        }
        var serialized_args = HxDeleteInferredLocationArgs_1.serializeHxDeleteInferredLocationArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(661, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteInternetHeadersOnMessage = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in DeleteInternetHeadersOnMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxDeleteInternetHeadersOnMessageArgs_1.serializeHxDeleteInternetHeadersOnMessageArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(797, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteLocationSuggestionsItem = function (args) {
        var serialized_args = HxDeleteLocationSuggestionsItemArgs_1.serializeHxDeleteLocationSuggestionsItemArgs(args);
        return this.runActor(269, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * DeleteMailItem: Actor used to delete user conversations/messages. Throws exception if used for groups. Throws exception if the target object should be permanently deleted, like target already in DeletedItems folder
    */
    HxActorAPIs.prototype.deleteMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in DeleteMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in DeleteMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxDeleteMailItemArgs_1.serializeHxDeleteMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(150, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * DeleteMailItem: Actor used to delete user conversations/messages. Throws exception if used for groups. Throws exception if the target object should be permanently deleted, like target already in DeletedItems folder
    */
    HxActorAPIs.prototype.deleteMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in DeleteMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in DeleteMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxDeleteMailItemArgs_1.serializeHxDeleteMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(150, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteMailItemByServerId = function (targetIds, args, actorCompletionNotificationType) {
        var serialized_args = HxDeleteMailItemArgs_1.serializeHxDeleteMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runServerIdTargetActor(407, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteMeetingTimeSuggestionsItem = function (args) {
        var serialized_args = HxDeleteMeetingTimeSuggestionsItemArgs_1.serializeHxDeleteMeetingTimeSuggestionsItemArgs(args);
        return this.runActor(322, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteReaction = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in DeleteReaction. Expected Types: HxMessageHeader");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(787, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.deleteRoomListsItem = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in DeleteRoomListsItem. Expected Types: HxAccount");
        }
        var serialized_args = HxDeleteRoomListsItemArgs_1.serializeHxDeleteRoomListsItemArgs(args);
        return this.runActor(80, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteRoomsItem = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in DeleteRoomsItem. Expected Types: HxAccount");
        }
        var serialized_args = HxDeleteRoomsItemArgs_1.serializeHxDeleteRoomsItemArgs(args);
        return this.runActor(83, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.deleteView = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in DeleteView. Expected Types: HxView");
        }
        var serialized_args = HxDeleteViewArgs_1.serializeHxDeleteViewArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(32, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deleteViewWithUndo = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in DeleteView. Expected Types: HxView");
        }
        var serialized_args = HxDeleteViewArgs_1.serializeHxDeleteViewArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(32, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.deprovisionMailbox = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in DeprovisionMailbox. Expected Types: HxAccount");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(323, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.disableAddIn = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in DisableAddIn. Expected Types: HxAccount");
        }
        var serialized_args = HxAddInInfoArgs_1.serializeHxAddInInfoArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(653, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * DisableWidgetData: Deletes Root::WritsWatch object to avoid cost of keeping it up to date.
    */
    HxActorAPIs.prototype.disableWidgetData = function () {
        return this.runActor(747, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.discardDraft = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in DiscardDraft. Expected Types: HxMessageHeader");
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(74, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.dismissReminder = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in DismissReminder. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxDismissReminderArgs_1.serializeHxDismissReminderArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(452, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * DoNotDisturbSettings
    * @param eventSettingLastModifiedTimeUtc Specifies the time when enabledDuringEvents was last changed. Required only when enabledDuringEvents is true.
    */
    HxActorAPIs.prototype.doNotDisturbSettings = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in DoNotDisturbSettings. Expected Types: HxAccount");
        }
        var serialized_args = HxDoNotDisturbSettingsArgs_1.serializeHxDoNotDisturbSettingsArgs(args);
        return this.runActor(621, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * DownloadAttachments: Cannot be used for URL attachments, since there is nothing for them to download.
    */
    HxActorAPIs.prototype.downloadAttachments = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAttachmentHeader) {
                throw new Error("Incorrect object type for target in DownloadAttachments. Expected Types: HxAttachmentHeader");
            }
        }
        var serialized_args = HxDownloadAttachmentsArgs_1.serializeHxDownloadAttachmentsArgs(args);
        return this.runActor(244, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.downloadExternalContent = function (targetIds) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for target in DownloadExternalContent. Expected Types: HxMessageHeader");
            }
        }
        return this.runActor(170, targetIds, '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.emptyView = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in EmptyView. Expected Types: HxView");
        }
        var serialized_args = HxEmptyViewArgs_1.serializeHxEmptyViewArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(187, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * EnableWidgetData: Creates Root::WidgetData object and keeps up to date with data optimized for compact views. Calling this actor when WidgetData is already enalbled is a no-op, so to change options (widget count, focused other support) actor DisableWidgetData must be called in-between. Failure to do so will fail with precondition violated
    */
    HxActorAPIs.prototype.enableWidgetData = function (args) {
        var serialized_args = HxEnableWidgetDataArgs_1.serializeHxEnableWidgetDataArgs(args);
        return this.runActor(746, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.endAllSearchSessions = function () {
        return this.runActor(562, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.endSearchSession = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in EndSearchSession. Expected Types: HxSearchSession");
        }
        return this.runActor(596, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * ExpandDistributionListForSmimeDraft:  This actor only does a one layer expansion of the distribution list. This means that if there are one or more distribution list contained in the expanded list, this actor does not expand them. It is up to the client to call this actor again to expand each distribution list that appears in the resulting list.
    */
    HxActorAPIs.prototype.expandDistributionListForSmimeDraft = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxPerson) {
            throw new Error("Incorrect object type for target in ExpandDistributionListForSmimeDraft. Expected Types: HxPerson");
        }
        var serialized_args = HxExpandDistributionListForSmimeDraftArgs_1.serializeHxExpandDistributionListForSmimeDraftArgs(args);
        return this.runActor(712, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * ExportAppointmentToICSFile: Should not be used on an appointment that hasn't been fully synced
    */
    HxActorAPIs.prototype.exportAppointmentToICSFile = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in ExportAppointmentToICSFile. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxExportAppointmentToICSFileArgs_1.serializeHxExportAppointmentToICSFileArgs(args);
        return this.runActor(749, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.exportContactToVCFFile = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxContact) {
            throw new Error("Incorrect object type for target in ExportContactToVCFFile. Expected Types: HxContact");
        }
        var serialized_args = HxExportContactToVCFFileArgs_1.serializeHxExportContactToVCFFileArgs(args);
        return this.runActor(794, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchAccessTokenForAddIn = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchAccessTokenForAddIn. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchAccessTokenForAddInArgs_1.serializeHxFetchAccessTokenForAddInArgs(args);
        return this.runActorWithResultsAsync(692, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchAddInMarketplaceUrl = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchAddInMarketplaceUrl. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(655, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(655, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(655, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.fetchAddInRoamingSettings = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchAddInRoamingSettings. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchAddInRoamingSettingsArgs_1.serializeHxFetchAddInRoamingSettingsArgs(args);
        return this.runActorWithResultsAsync(688, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchAddIns = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchAddIns. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(656, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(656, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(656, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.fetchAppointmentBody = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in FetchAppointmentBody. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxFetchAppointmentBodyArgs_1.serializeHxFetchAppointmentBodyArgs(args);
        return this.runActor(399, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchAppointmentByDeviceId = function (args) {
        var serialized_args = HxFetchAppointmentByDeviceIdArgs_1.serializeHxFetchAppointmentByDeviceIdArgs(args);
        return this.runActorWithResultsAsync(408, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchAppointments = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchAppointments. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchAppointmentsArgs_1.serializeHxFetchAppointmentsArgs(args);
        return this.runActorWithResultsAsync(412, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchAttachmentByServerId = function (targetId, args) {
        var serialized_args = HxFetchAttachmentByServerIdArgs_1.serializeHxFetchAttachmentByServerIdArgs(args);
        return this.runServerIdTargetActorWithResultsAsync(524, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchAutoDetect = function (args) {
        var serialized_args = HxFetchAutoDetectArgs_1.serializeHxFetchAutoDetectArgs(args);
        return this.runActorWithResultsAsync(617, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchAutoReplyConfiguration = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in FetchAutoReplyConfiguration. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxFetchAutoReplyConfigurationArgs_1.serializeHxFetchAutoReplyConfigurationArgs(args);
        return this.runActor(414, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchAvailability = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchAvailability. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchAvailabilityArgs_1.serializeHxFetchAvailabilityArgs(args);
        return this.runActorWithResultsAsync(425, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchBlockedSenderAndDomainList = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchBlockedSenderAndDomainList. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(643, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchCalendarFeeds = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchCalendarFeeds. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchCalendarFeedsArgs_1.serializeHxFetchCalendarFeedsArgs(args);
        return this.runActor(176, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchCalendarSharingPermissionCollection = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in FetchCalendarSharingPermissionCollection. Expected Types: HxCalendarData");
        }
        var serialized_args = HxFetchCalendarSharingPermissionCollectionArgs_1.serializeHxFetchCalendarSharingPermissionCollectionArgs(args);
        return this.runActor(314, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchCalendarSharingPermissionForRecipient = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in FetchCalendarSharingPermissionForRecipient. Expected Types: HxCalendarData");
        }
        var serialized_args = HxFetchCalendarSharingPermissionForRecipientArgs_1.serializeHxFetchCalendarSharingPermissionForRecipientArgs(args);
        return this.runActorWithResultsAsync(315, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchCalendarView = function (args) {
        var serialized_args = HxFetchCalendarViewArgs_1.serializeHxFetchCalendarViewArgs(args);
        return this.runActor(426, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * FetchCdnFiles: Retrieves full paths for CDN files which are identified with case-sensitive relative paths. Fetches are issued for missing files
    */
    HxActorAPIs.prototype.fetchCdnFiles = function (args) {
        var _this = this;
        var serialized_args = HxFetchCdnFilesArgs_1.serializeHxFetchCdnFilesArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(726, [], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(726, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(726, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.fetchComplianceConfiguration = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchComplianceConfiguration. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(422, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchContactByGraphId = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchContactByGraphId. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchContactByGraphIdArgs_1.serializeHxFetchContactByGraphIdArgs(args);
        return this.runActorWithResultsAsync(532, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchContactByServerId = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchContactByServerId. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchContactByServerIdArgs_1.serializeHxFetchContactByServerIdArgs(args);
        return this.runActorWithResultsAsync(791, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchContacts = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchContacts. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(537, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchCustomPropertiesOnAppointment = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in FetchCustomPropertiesOnAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxFetchCustomPropertiesOnAppointmentArgs_1.serializeHxFetchCustomPropertiesOnAppointmentArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(666, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(666, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(666, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.fetchCustomPropertiesOnMessage = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in FetchCustomPropertiesOnMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxFetchCustomPropertiesOnMessageArgs_1.serializeHxFetchCustomPropertiesOnMessageArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(665, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(665, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(665, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.fetchDelegates = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchDelegates. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(646, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * FetchDistributionListMembers
    * @param offset If paging is used, response will return DL members starting at offset. By deafault it is set 0
    * @param pageSize If paging is used then number of DL members in the response is limited by pageSize. By deafault it is set to 0 and all DL members are returned
    */
    HxActorAPIs.prototype.fetchDistributionListMembers = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchDistributionListMembers. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchDistributionListMembersArgs_1.serializeHxFetchDistributionListMembersArgs(args);
        return this.runActorWithResultsAsync(565, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchEncryptionCertificates = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in FetchEncryptionCertificates. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxFetchEncryptionCertificatesArgs_1.serializeHxFetchEncryptionCertificatesArgs(args);
        return this.runActor(411, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchFavoriteItems = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchFavoriteItems. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(549, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchGroupDetail = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxGroup) {
            throw new Error("Incorrect object type for target in FetchGroupDetail. Expected Types: HxGroup");
        }
        var serialized_args = HxFetchWithContextArgs_1.serializeHxFetchWithContextArgs(args);
        return this.runActor(447, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchGroupList = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchGroupList. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(577, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchHolidayCalendarCatalog = function (args) {
        var serialized_args = HxFetchHolidayCalendarCatalogArgs_1.serializeHxFetchHolidayCalendarCatalogArgs(args);
        return this.runActor(197, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchInternetHeadersOnMessage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in FetchInternetHeadersOnMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxFetchInternetHeadersOnMessageArgs_1.serializeHxFetchInternetHeadersOnMessageArgs(args);
        return this.runActorWithResultsAsync(798, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * FetchIsHxSCapable: For Pre-account-create check
    */
    HxActorAPIs.prototype.fetchIsHxSCapable = function (args) {
        var serialized_args = HxFetchIsHxSCapableArgs_1.serializeHxFetchIsHxSCapableArgs(args);
        return this.runActorWithResultsAsync(594, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchLocalEvents = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchLocalEvents. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchLocalEventsArgs_1.serializeHxFetchLocalEventsArgs(args);
        return this.runActor(351, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * FetchLocationByEmail: Given an EmailAddress (For E.g. of Conference Room) returns the LocationEntityData
    */
    HxActorAPIs.prototype.fetchLocationByEmail = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchLocationByEmail. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchLocationByEmailArgs_1.serializeHxFetchLocationByEmailArgs(args);
        return this.runActorWithResultsAsync(800, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchLocationSuggestions = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchLocationSuggestions. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchLocationSuggestionsArgs_1.serializeHxFetchLocationSuggestionsArgs(args);
        return this.runActorWithResultsAsync(424, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchMasterCategoryList = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchMasterCategoryList. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(494, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * FetchMeetingTimeSuggestions
    * @param isLocationRequired If unsure, passing false is recommended.
    * @param suggestLocation If unsure, passing false is recommended.
    * @param isOrganizerOptional If unsure, passing false is recommended.
    * @param suggestionsRange If unsure, passing MeetingTimeSuggestionsRange::Unknown is recommended.
    */
    HxActorAPIs.prototype.fetchMeetingTimeSuggestions = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchMeetingTimeSuggestions. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchMeetingTimeSuggestionsArgs_1.serializeHxFetchMeetingTimeSuggestionsArgs(args);
        return this.runActorWithResultsAsync(427, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchMessageByServerId = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount && targetId.getObjectType() !== HxObjectType_1.default.HxGroup) {
            throw new Error("Incorrect object type for target in FetchMessageByServerId. Expected Types: HxAccount, HxGroup");
        }
        var serialized_args = HxFetchMessageByServerIdArgs_1.serializeHxFetchMessageByServerIdArgs(args);
        return this.runActorWithResultsAsync(372, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchMessages = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for target in FetchMessages. Expected Types: HxMessageHeader");
            }
        }
        var serialized_args = HxFetchMessagesArgs_1.serializeHxFetchMessagesArgs(args);
        return this.runActor(311, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchMessagesForGroupCard = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxGroup) {
            throw new Error("Incorrect object type for target in FetchMessagesForGroupCard. Expected Types: HxGroup");
        }
        var serialized_args = HxFetchMessagesForGroupCardArgs_1.serializeHxFetchMessagesForGroupCardArgs(args);
        return this.runActor(538, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * FetchMimeContent: Fetches the full MIME encoding of the target message and returns a path to the temporary file containing the MIME. MIME files persist for the duration of a boot session.
    */
    HxActorAPIs.prototype.fetchMimeContent = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in FetchMimeContent. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxFetchMimeContentArgs_1.serializeHxFetchMimeContentArgs(args);
        return this.runActorWithResultsAsync(799, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchMoreMessageHeaders = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in FetchMoreMessageHeaders. Expected Types: HxView");
        }
        var serialized_args = HxFetchMoreMessageHeadersArgs_1.serializeHxFetchMoreMessageHeadersArgs(args);
        return this.runActorWithResultsAsync(368, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * FetchPhoto
    * @param refetchFromServer Only set to true to refetch updated (using REST API) group avatar from server.
    */
    HxActorAPIs.prototype.fetchPhoto = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchPhoto. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchPhotoArgs_1.serializeHxFetchPhotoArgs(args);
        return this.runActorWithResultsAsync(436, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchRemoteMailboxSyncHealth = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchRemoteMailboxSyncHealth. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActorWithResultsAsync(566, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.fetchRoomLists = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchRoomLists. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchRoomListsArgs_1.serializeHxFetchRoomListsArgs(args);
        return this.runActor(428, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchRooms = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchRooms. Expected Types: HxAccount");
        }
        var serialized_args = HxFetchRoomsArgs_1.serializeHxFetchRoomsArgs(args);
        return this.runActor(429, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchRules = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FetchRules. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(421, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchSurfaceHubMeetingAttendees = function (args) {
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActorWithResultsAsync(369, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * FetchToDoTasksFromMessage: This will fetch ToDoTasks that are associated with a MessageHeader. The MessageData must already be Fetched to call this. The ToDoTasks will be populated on the Message's Account.
    */
    HxActorAPIs.prototype.fetchToDoTasksFromMessage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in FetchToDoTasksFromMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxFetchToDoTasksFromMessageArgs_1.serializeHxFetchToDoTasksFromMessageArgs(args);
        return this.runActor(741, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchUnreadCountForGroups = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxGroup) {
                throw new Error("Incorrect object type for target in FetchUnreadCountForGroups. Expected Types: HxGroup");
            }
        }
        var serialized_args = HxFetchUnreadCountForGroupsArgs_1.serializeHxFetchUnreadCountForGroupsArgs(args);
        return this.runActor(488, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchView = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxView) {
                throw new Error("Incorrect object type for target in FetchView. Expected Types: HxView");
            }
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(458, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.fetchWeather = function (args) {
        var serialized_args = HxFetchWeatherArgs_1.serializeHxFetchWeatherArgs(args);
        return this.runActor(430, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.filterContacts = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in FilterContacts. Expected Types: HxAccount");
        }
        var serialized_args = HxFilterContactsArgs_1.serializeHxFilterContactsArgs(args);
        return this.runActor(775, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.findAttachmentsByPerson = function (args) {
        var serialized_args = HxFindAttachmentsByPersonArgs_1.serializeHxFindAttachmentsByPersonArgs(args);
        return this.runActorWithResultsAsync(534, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.findCalendarByDeviceId = function (args) {
        var serialized_args = HxFindCalendarByDeviceIdArgs_1.serializeHxFindCalendarByDeviceIdArgs(args);
        return this.runActorWithResultsAsync(689, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * FindConflictingMeetings
    * @param timeZoneId IANA timezone of the client UI used to correctly find conflicts with floating (all day) appointments. If left empty, HxCore will attempt to query the current timezone from the OS.
    * @param meetingToExcludeServerId Appointments matching this server id (or whose master matches this server id) won't be considered a conflict.
    * @param meetingToExcludeSubject If either meetingToExcludeServerId or meetingToExcludeCalendarItemReferenceId are specified and not empty, this argument will be ignored.
    * @param meetingToExcludeCalendarItemReferenceId Appointments matching this CalendarItemReferenceId won't be considered a conflict.
    */
    HxActorAPIs.prototype.findConflictingMeetings = function (args) {
        var serialized_args = HxFindConflictingMeetingsArgs_1.serializeHxFindConflictingMeetingsArgs(args);
        return this.runActorWithResultsAsync(498, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.findContactsBySearchString = function (args) {
        var serialized_args = HxFindContactsBySearchStringArgs_1.serializeHxFindContactsBySearchStringArgs(args);
        return this.runActorWithResultsAsync(533, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.findConversationsByPerson = function (args) {
        var serialized_args = HxFindConversationsByPersonArgs_1.serializeHxFindConversationsByPersonArgs(args);
        return this.runActorWithResultsAsync(527, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.findMeetingsByAttendee = function (args) {
        var serialized_args = HxFindMeetingsByAttendeeArgs_1.serializeHxFindMeetingsByAttendeeArgs(args);
        return this.runActorWithResultsAsync(506, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.flagMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in FlagMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in FlagMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxFlagMailItemArgs_1.serializeHxFlagMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(140, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.flagMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in FlagMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in FlagMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxFlagMailItemArgs_1.serializeHxFlagMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(140, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.flagMailItemByServerId = function (targetIds, args, actorCompletionNotificationType) {
        var serialized_args = HxFlagMailItemArgs_1.serializeHxFlagMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runServerIdTargetActor(406, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * ForwardAppointment
    * @param draftBody Contains the HTML body as well as if we should pass the body as smartReply or not. If null, it will leave the existing value.
    */
    HxActorAPIs.prototype.forwardAppointment = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in ForwardAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxCreateMeetingReplyArgs_1.serializeHxCreateMeetingReplyArgs(args);
        return this.runActorWithResultsAsync(486, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.forwardCalendarEvent = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in ForwardCalendarEvent. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxForwardCalendarEventArgs_1.serializeHxForwardCalendarEventArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(85, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * ForwardMessage
    * @param draftBody Contains the HTML body as well as isFirstBody to determine if we should pass the body as smartReply or not.
    */
    HxActorAPIs.prototype.forwardMessage = function (targetId, args, actorCompletionNotificationType) {
        if (!targetId[0].isNil() && targetId[0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for first item of the Pair Target in ForwardMessage. Expected ConversationHeader");
        }
        if (!targetId[1].isNil() && targetId[1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for second item of the Pair Target in ForwardMessage. Expected MessageHeader");
        }
        var serialized_args = HxCreateReplyDraftArgs_1.serializeHxCreateReplyDraftArgs(args);
        return this.runPairTargetActorWithResultsAsync(219, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.forwardMessageAsEmlAttachment = function (targetId, args, actorCompletionNotificationType) {
        if (!targetId[0].isNil() && targetId[0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for first item of the Pair Target in ForwardMessageAsEmlAttachment. Expected ConversationHeader");
        }
        if (!targetId[1].isNil() && targetId[1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for second item of the Pair Target in ForwardMessageAsEmlAttachment. Expected MessageHeader");
        }
        var serialized_args = HxStringArgs_1.serializeHxStringArgs(args);
        return this.runPairTargetActorWithResultsAsync(591, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.generateAdvertisingSetting = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in GenerateAdvertisingSetting. Expected Types: HxAccount");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(795, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.getAppointmentExceptions = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in GetAppointmentExceptions. Expected Types: HxAppointmentHeader");
        }
        return this.runActorWithResultsAsync(618, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * GetAppointmentForProtocolActivation: This actor is used to load appointment from hexized event Id
    * @param hexizedAppointmentId eventId from protocol activation args - hexized objectID
    */
    HxActorAPIs.prototype.getAppointmentForProtocolActivation = function (args) {
        var serialized_args = HxGetAppointmentForProtocolActivationArgs_1.serializeHxGetAppointmentForProtocolActivationArgs(args);
        return this.runActorWithResultsAsync(625, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * GetAppointmentForProtocolActivationByServerId: This actor is used to load appointment from hexized event ServerId
    * @param hexizedAppointmentServerId A hexized AppointmentHeader ServerId
    * @param hexizedAccountId accountId from protocol activation args - hexized objectID
    */
    HxActorAPIs.prototype.getAppointmentForProtocolActivationByServerId = function (args) {
        var serialized_args = HxGetAppointmentForProtocolActivationByServerIdArgs_1.serializeHxGetAppointmentForProtocolActivationByServerIdArgs(args);
        return this.runActorWithResultsAsync(626, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.getCertificateInfoForCertificates = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in GetCertificateInfoForCertificates. Expected Types: HxAccount");
        }
        var serialized_args = HxGetCertificateInfoForCertificatesArgs_1.serializeHxGetCertificateInfoForCertificatesArgs(args);
        return this.runActorWithResultsAsync(760, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * GetConversationIndexBasedOnSubstringOrDateTime
    * @param substring If the collection matched by collectionId is sorted by Subject or Sender, this param is required
    * @param dateTime If the collection matched by collectionId is sorted by Date, this param is required
    */
    HxActorAPIs.prototype.getConversationIndexBasedOnSubstringOrDateTime = function (args) {
        var serialized_args = HxGetConversationIndexBasedOnSubstringOrDateTimeArgs_1.serializeHxGetConversationIndexBasedOnSubstringOrDateTimeArgs(args);
        return this.runActorWithResultsAsync(731, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.getHexizedObjectIds = function (args) {
        var serialized_args = HxGetHexizedObjectIdsArgs_1.serializeHxGetHexizedObjectIdsArgs(args);
        return this.runActorWithResultsAsync(627, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.getHexizedServerIds = function (args) {
        var serialized_args = HxGetHexizedServerIdsArgs_1.serializeHxGetHexizedServerIdsArgs(args);
        return this.runActorWithResultsAsync(628, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * GetMessageHeaderForProtocolActivation: This actor is used to translate a Message hexized ID to its corresponding ObjectID in order to load the object.
    * @param hexizedMessageHeaderId messageHeaderId from protocol activation args - hexized objectID
    */
    HxActorAPIs.prototype.getMessageHeaderForProtocolActivation = function (args) {
        var serialized_args = HxGetMessageHeaderForProtocolActivationArgs_1.serializeHxGetMessageHeaderForProtocolActivationArgs(args);
        return this.runActorWithResultsAsync(734, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * GetNextInstanceFromAppointment: Gets next appointment instance/exception from the given MasterId.
    */
    HxActorAPIs.prototype.getNextInstanceFromAppointment = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in GetNextInstanceFromAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxGetNextInstanceArgs_1.serializeHxGetNextInstanceArgs(args);
        return this.runActorWithResultsAsync(736, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * GetNextInstanceFromMessage: Gets next appointment instance/exception from the given MessageHeader
    */
    HxActorAPIs.prototype.getNextInstanceFromMessage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in GetNextInstanceFromMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxGetNextInstanceArgs_1.serializeHxGetNextInstanceArgs(args);
        return this.runActorWithResultsAsync(735, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * GetPreviousAndNextAppointmentInstances: Gets previous and next instance/exception's UTC start times for a given instance/exception in a series
    */
    HxActorAPIs.prototype.getPreviousAndNextAppointmentInstances = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in GetPreviousAndNextAppointmentInstances. Expected Types: HxAppointmentHeader");
        }
        return this.runActorWithResultsAsync(651, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.ignoreConversation = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in IgnoreConversation. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in IgnoreConversation. Expected MessageHeader");
            }
        }
        var serialized_args = HxIgnoreConversationArgs_1.serializeHxIgnoreConversationArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(352, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.importICSFile = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in ImportICSFile. Expected Types: HxCalendarData");
        }
        var serialized_args = HxImportICSFileArgs_1.serializeHxImportICSFileArgs(args);
        return this.runActorWithResultsAsync(763, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * InstallAddIn
    * @param manifest If set, manifestUrl, productId, and marketPlaceInfo should not be set.
    * @param manifestUrl If set, manifest,  productId, and marketPlaceInfo should not be set.
    * @param marketPlaceInfo If set, manifest,  productId, and manifestUrl should not be set.
    * @param productId If set, manifest,  marketPlaceInfo, and manifestUrl should not be set.
    */
    HxActorAPIs.prototype.installAddIn = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in InstallAddIn. Expected Types: HxAccount");
        }
        var serialized_args = HxInstallAddInArgs_1.serializeHxInstallAddInArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(652, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(652, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(652, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.instrumentAnswersSearchResultsDisplayed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentAnswersSearchResultsDisplayed. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchResultsDisplayedArgs_1.serializeHxInstrumentSearchResultsDisplayedArgs(args);
        return this.runActor(696, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentCalendarSearchInteraction = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in InstrumentCalendarSearchInteraction. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxInstrumentCalendarSearchInteractionArgs_1.serializeHxInstrumentCalendarSearchInteractionArgs(args);
        return this.runActor(685, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentCalendarSearchResultsDisplayed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentCalendarSearchResultsDisplayed. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchResultsDisplayedArgs_1.serializeHxInstrumentSearchResultsDisplayedArgs(args);
        return this.runActor(682, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentFileSearchResultsDisplayed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentFileSearchResultsDisplayed. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchResultsDisplayedArgs_1.serializeHxInstrumentSearchResultsDisplayedArgs(args);
        return this.runActor(781, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentMailSearchInteraction = function (targetId, args) {
        if (!targetId[0].isNil() && targetId[0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for first item of the Pair Target in InstrumentMailSearchInteraction. Expected ConversationHeader");
        }
        if (!targetId[1].isNil() && targetId[1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for second item of the Pair Target in InstrumentMailSearchInteraction. Expected MessageHeader");
        }
        var serialized_args = HxInstrumentMailSearchInteractionArgs_1.serializeHxInstrumentMailSearchInteractionArgs(args);
        return this.runPairTargetActor(558, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentMailSearchResultsDisplayed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentMailSearchResultsDisplayed. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchResultsDisplayedArgs_1.serializeHxInstrumentSearchResultsDisplayedArgs(args);
        return this.runActor(681, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentPeopleSearchResultsDisplayed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentPeopleSearchResultsDisplayed. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentPeopleSearchResultsDisplayedArgs_1.serializeHxInstrumentPeopleSearchResultsDisplayedArgs(args);
        return this.runActor(683, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentRecipientSearchResultsDisplayed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentRecipientSearchResultsDisplayed. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchResultsDisplayedArgs_1.serializeHxInstrumentSearchResultsDisplayedArgs(args);
        return this.runActor(777, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * InstrumentSearchEvent
    * @param key The key to use with SearchInstrumentationScenario::CustomKey
    */
    HxActorAPIs.prototype.instrumentSearchEvent = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentSearchEvent. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchEventArgs_1.serializeHxInstrumentSearchEventArgs(args);
        return this.runActor(684, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentSearchSubmittedExplicitly = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentSearchSubmittedExplicitly. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchSubmittedExplicitlyArgs_1.serializeHxInstrumentSearchSubmittedExplicitlyArgs(args);
        return this.runActor(512, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentSearchSuggestionActivated = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchInstrumentationData) {
            throw new Error("Incorrect object type for target in InstrumentSearchSuggestionActivated. Expected Types: HxSearchInstrumentationData");
        }
        var serialized_args = HxInstrumentSearchSuggestionActivatedArgs_1.serializeHxInstrumentSearchSuggestionActivatedArgs(args);
        return this.runActor(559, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.instrumentSearchSuggestionsDisplayed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in InstrumentSearchSuggestionsDisplayed. Expected Types: HxSearchSession");
        }
        var serialized_args = HxInstrumentSearchResultsDisplayedArgs_1.serializeHxInstrumentSearchResultsDisplayedArgs(args);
        return this.runActor(511, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.isMessageSignerEncryptionCertificateInLocalCache = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in IsMessageSignerEncryptionCertificateInLocalCache. Expected Types: HxMessageHeader");
        }
        return this.runActorWithResultsAsync(593, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.loadSMIMEContent = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in LoadSMIMEContent. Expected Types: HxMessageHeader");
        }
        var serialized_args = [];
        return this.runActor(122, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.manualSyncCalendar = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in ManualSyncCalendar. Expected Types: HxCalendarData");
        }
        return this.runActor(86, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.markActivitiesAsDismissed = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxActivityFeedItem) {
                throw new Error("Incorrect object type for target in MarkActivitiesAsDismissed. Expected Types: HxActivityFeedItem");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(810, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.markActivitiesAsSeen = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxActivityFeedItem) {
                throw new Error("Incorrect object type for target in MarkActivitiesAsSeen. Expected Types: HxActivityFeedItem");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(808, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.markAllActivitiesAsDismissed = function (actorCompletionNotificationType) {
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(809, [], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.markAllActivitiesAsSeen = function (args, actorCompletionNotificationType) {
        var serialized_args = HxMarkAllActivitiesArgs_1.serializeHxMarkAllActivitiesArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(807, [], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markAsArchiveView = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in MarkAsArchiveView. Expected Types: HxView");
        }
        return this.runActor(695, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.markAsReadAndArchive = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkAsReadAndArchive. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkAsReadAndArchive. Expected MessageHeader");
            }
        }
        var serialized_args = HxArchiveMailItemArgs_1.serializeHxArchiveMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(341, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markAsReadAndArchiveWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkAsReadAndArchive. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkAsReadAndArchive. Expected MessageHeader");
            }
        }
        var serialized_args = HxArchiveMailItemArgs_1.serializeHxArchiveMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(341, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markAsReadAndArchiveByServerId = function (targetId, args, actorCompletionNotificationType) {
        var serialized_args = HxMarkAsReadAndArchiveByServerIdArgs_1.serializeHxMarkAsReadAndArchiveByServerIdArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runServerIdTargetActor(630, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markAsReadAndDeleteMail = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkAsReadAndDeleteMail. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkAsReadAndDeleteMail. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkAsReadAndDeleteMailArgs_1.serializeHxMarkAsReadAndDeleteMailArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(290, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markAsReadAndDeleteMailWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkAsReadAndDeleteMail. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkAsReadAndDeleteMail. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkAsReadAndDeleteMailArgs_1.serializeHxMarkAsReadAndDeleteMailArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(290, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markAsScheduledView = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in MarkAsScheduledView. Expected Types: HxView");
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(454, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markMailItemAsJunk = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkMailItemAsJunk. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkMailItemAsJunk. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkMailItemAsJunkArgs_1.serializeHxMarkMailItemAsJunkArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(346, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markMailItemAsJunkWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkMailItemAsJunk. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkMailItemAsJunk. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkMailItemAsJunkArgs_1.serializeHxMarkMailItemAsJunkArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(346, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markMailItemAsPhishing = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkMailItemAsPhishing. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkMailItemAsPhishing. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkMailItemAsPhishingArgs_1.serializeHxMarkMailItemAsPhishingArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(622, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markMailItemAsPhishingWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkMailItemAsPhishing. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkMailItemAsPhishing. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkMailItemAsPhishingArgs_1.serializeHxMarkMailItemAsPhishingArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(622, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * MarkMailItemRead
    * @param isUserInitiated Used for instrumentation to differentiate between when the user initiated the MarkMailItemRead and when the system did. E.g. Clicking a button is user initiated, automatically marking an email as read after it is opened is not.
    */
    HxActorAPIs.prototype.markMailItemRead = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkMailItemRead. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkMailItemRead. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkMailItemReadArgs_1.serializeHxMarkMailItemReadArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(149, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * MarkMailItemRead
    * @param isUserInitiated Used for instrumentation to differentiate between when the user initiated the MarkMailItemRead and when the system did. E.g. Clicking a button is user initiated, automatically marking an email as read after it is opened is not.
    */
    HxActorAPIs.prototype.markMailItemReadWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MarkMailItemRead. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MarkMailItemRead. Expected MessageHeader");
            }
        }
        var serialized_args = HxMarkMailItemReadArgs_1.serializeHxMarkMailItemReadArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(149, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * MarkMailItemReadByServerId
    * @param isUserInitiated Used for instrumentation to differentiate between when the user initiated the MarkMailItemRead and when the system did. E.g. Clicking a button is user initiated, automatically marking an email as read after it is opened is not.
    */
    HxActorAPIs.prototype.markMailItemReadByServerId = function (targetIds, args, actorCompletionNotificationType) {
        var serialized_args = HxMarkMailItemReadArgs_1.serializeHxMarkMailItemReadArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runServerIdTargetActor(404, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markOneRMContentViewed = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in MarkOneRMContentViewed. Expected Types: HxAccount");
        }
        var serialized_args = HxMarkOneRMContentViewedArgs_1.serializeHxMarkOneRMContentViewedArgs(args);
        return this.runActor(304, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.markPremiumSubscriptionAdActivated = function (actorCompletionNotificationType) {
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(358, [], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.markViewAsRead = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxView) {
                throw new Error("Incorrect object type for target in MarkViewAsRead. Expected Types: HxView");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(367, targetIds, '[]', completionNotificationType);
    };
    /**
    * MockAction: For Unit testing
    */
    HxActorAPIs.prototype.mockAction = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in MockAction. Expected Types: HxAccount");
        }
        var serialized_args = HxMockActionArgs_1.serializeHxMockActionArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(582, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * MockActionWithCustomFailureResults: For Unit testing. Tests Actors which return Custom Failure Results.
    */
    HxActorAPIs.prototype.mockActionWithCustomFailureResults = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in MockActionWithCustomFailureResults. Expected Types: HxAccount");
        }
        var serialized_args = HxMockActionWithResultsArgs_1.serializeHxMockActionWithResultsArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(632, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(632, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(632, JSON.parse(failureresults))); }); });
    };
    /**
    * MockActionWithResults: For Unit testing
    */
    HxActorAPIs.prototype.mockActionWithResults = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in MockActionWithResults. Expected Types: HxAccount");
        }
        var serialized_args = HxMockActionWithResultsArgs_1.serializeHxMockActionWithResultsArgs(args);
        return this.runActorWithResultsAsync(583, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * ModuleActivated: This actor is used to notify Hx that one of the modules like Mail or Calendar becomes active
    */
    HxActorAPIs.prototype.moduleActivated = function (args) {
        var serialized_args = HxModuleIdentifierArgs_1.serializeHxModuleIdentifierArgs(args);
        return this.runActor(444, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * ModuleDeactivated: This actor is used to notify Hx that one of the modules like Mail or Calendar becomes inactive
    */
    HxActorAPIs.prototype.moduleDeactivated = function (args) {
        var serialized_args = HxModuleIdentifierArgs_1.serializeHxModuleIdentifierArgs(args);
        return this.runActor(445, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.moveFavoriteItem = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxFavoriteItem) {
            throw new Error("Incorrect object type for target in MoveFavoriteItem. Expected Types: HxFavoriteItem");
        }
        var serialized_args = HxMoveFavoriteItemArgs_1.serializeHxMoveFavoriteItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(500, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.moveFavoriteItemWithUndo = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxFavoriteItem) {
            throw new Error("Incorrect object type for target in MoveFavoriteItem. Expected Types: HxFavoriteItem");
        }
        var serialized_args = HxMoveFavoriteItemArgs_1.serializeHxMoveFavoriteItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(500, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.moveFavoriteItemInUnifiedFavorites = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxFavoriteItem) {
            throw new Error("Incorrect object type for target in MoveFavoriteItemInUnifiedFavorites. Expected Types: HxFavoriteItem");
        }
        var serialized_args = HxMoveFavoriteItemInUnifiedFavoritesArgs_1.serializeHxMoveFavoriteItemInUnifiedFavoritesArgs(args);
        return this.runActor(750, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.moveMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MoveMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MoveMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxMoveMailItemArgs_1.serializeHxMoveMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(151, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.moveMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MoveMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MoveMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxMoveMailItemArgs_1.serializeHxMoveMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(151, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.moveToFocusedOther = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MoveToFocusedOther. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MoveToFocusedOther. Expected MessageHeader");
            }
        }
        var serialized_args = HxMoveToFocusedOtherArgs_1.serializeHxMoveToFocusedOtherArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(296, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.moveToPreselected = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MoveToPreselected. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MoveToPreselected. Expected MessageHeader");
            }
        }
        var serialized_args = HxMoveToPreselectedArgs_1.serializeHxMoveToPreselectedArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(342, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.moveToPreselectedWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in MoveToPreselected. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in MoveToPreselected. Expected MessageHeader");
            }
        }
        var serialized_args = HxMoveToPreselectedArgs_1.serializeHxMoveToPreselectedArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(342, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * MoveView
    * @param moveAfterViewId The sort position of the moved view will be after this view.
                      MoveAfterViewId must be either the parent view (to place at the
                      top of the child list) or a peer view.
                      NOTE: Can only be set when Account::MailAccountData::SortViewsAlphabetically is false
    */
    HxActorAPIs.prototype.moveView = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in MoveView. Expected Types: HxView");
        }
        var serialized_args = HxMoveViewArgs_1.serializeHxMoveViewArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(209, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * MoveView
    * @param moveAfterViewId The sort position of the moved view will be after this view.
                      MoveAfterViewId must be either the parent view (to place at the
                      top of the child list) or a peer view.
                      NOTE: Can only be set when Account::MailAccountData::SortViewsAlphabetically is false
    */
    HxActorAPIs.prototype.moveViewWithUndo = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in MoveView. Expected Types: HxView");
        }
        var serialized_args = HxMoveViewArgs_1.serializeHxMoveViewArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(209, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.onBootCompleted = function () {
        return this.runActor(469, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.onForegroundBooting = function () {
        return this.runActor(440, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.onWatermarkPushNotification = function (args) {
        var serialized_args = HxOnWatermarkPushNotificationArgs_1.serializeHxOnWatermarkPushNotificationArgs(args);
        return this.runActorWithResultsAsync(420, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.permanentlyDeleteMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in PermanentlyDeleteMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in PermanentlyDeleteMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxDeleteMailItemArgs_1.serializeHxDeleteMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(611, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.pinMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in PinMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in PinMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxPinMailItemArgs_1.serializeHxPinMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(714, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.pinMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in PinMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in PinMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxPinMailItemArgs_1.serializeHxPinMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(714, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.pinMailItemByServerId = function (targetIds, args, actorCompletionNotificationType) {
        var serialized_args = HxPinMailItemArgs_1.serializeHxPinMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runServerIdTargetActor(715, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.pinView = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in PinView. Expected Types: HxView");
        }
        var serialized_args = HxTileIdArgs_1.serializeHxTileIdArgs(args);
        return this.runActor(202, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * PrepareToPotentiallySuspendHxCore: This actor is used to notify Hx that Application may be suspended in a short time
    */
    HxActorAPIs.prototype.prepareToPotentiallySuspendHxCore = function () {
        return this.runActor(678, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * PrepareToSuspendHxCore: This actor is used to notify Hx that Application is suspending
    */
    HxActorAPIs.prototype.prepareToSuspendHxCore = function () {
        return this.runActor(677, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * PreviewICSFile: Must call CloseICSFile on returned PreviewICSResult after closing ics files to avoid leaks
    */
    HxActorAPIs.prototype.previewICSFile = function (args) {
        var serialized_args = HxOpenICSFileArgs_1.serializeHxOpenICSFileArgs(args);
        return this.runActorWithResultsAsync(743, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * PreviewVCFFile: Must call CloseVCFFile on returned PreviewVCFResult after closing vcf files to avoid leaks
    */
    HxActorAPIs.prototype.previewVCFFile = function (args) {
        var serialized_args = HxOpenVCFFileArgs_1.serializeHxOpenVCFFileArgs(args);
        return this.runActorWithResultsAsync(792, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.prewarmSearch = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in PrewarmSearch. Expected Types: HxSearchSession");
        }
        var serialized_args = HxPrewarmSearchArgs_1.serializeHxPrewarmSearchArgs(args);
        return this.runActor(16, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.refreshCalendar = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RefreshCalendar. Expected Types: HxAccount");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(325, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * RefreshViewFilter: Makes newly read mail items disappear from the unread view by clearing the deferred objects table. No notifications will be sent, so this action must be accompanied by manual UI view refresh
    */
    HxActorAPIs.prototype.refreshViewFilter = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in RefreshViewFilter. Expected Types: HxView");
        }
        return this.runActor(649, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.removeAccount = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RemoveAccount. Expected Types: HxAccount");
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(73, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeAtMentionsRecipient = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in RemoveAtMentionsRecipient. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxRemoveAtMentionsRecipientArgs_1.serializeHxRemoveAtMentionsRecipientArgs(args);
        return this.runActor(273, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.removeAttachmentFromAppointment = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in RemoveAttachmentFromAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxRemoveAttachmentFromAppointmentArgs_1.serializeHxRemoveAttachmentFromAppointmentArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(370, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeAttachmentFromDraft = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in RemoveAttachmentFromDraft. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxRemoveAttachmentFromDraftArgs_1.serializeHxRemoveAttachmentFromDraftArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(10, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeBlockedSenderAndDomain = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RemoveBlockedSenderAndDomain. Expected Types: HxAccount");
        }
        var serialized_args = HxStringArgs_1.serializeHxStringArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(642, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeCachedRecipient = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RemoveCachedRecipient. Expected Types: HxAccount");
        }
        var serialized_args = HxRemoveCachedRecipientArgs_1.serializeHxRemoveCachedRecipientArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(483, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeCalendar = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RemoveCalendar. Expected Types: HxAccount");
        }
        var serialized_args = HxRemoveCalendarArgs_1.serializeHxRemoveCalendarArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(260, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeDelegates = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RemoveDelegates. Expected Types: HxAccount");
        }
        var serialized_args = HxRemoveDelegatesArgs_1.serializeHxRemoveDelegatesArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(669, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeFailedCreatedAccount = function (targetIds) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in RemoveFailedCreatedAccount. Expected Types: HxAccount");
            }
        }
        return this.runActor(239, targetIds, '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.removeFavoriteGroup = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxGroup) {
                throw new Error("Incorrect object type for target in RemoveFavoriteGroup. Expected Types: HxGroup");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(477, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.removeFavoriteGroupWithUndo = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxGroup) {
                throw new Error("Incorrect object type for target in RemoveFavoriteGroup. Expected Types: HxGroup");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(477, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.removeFavoriteItem = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxFavoriteItem) {
                throw new Error("Incorrect object type for target in RemoveFavoriteItem. Expected Types: HxFavoriteItem");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(476, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.removeFavoriteItemWithUndo = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxFavoriteItem) {
                throw new Error("Incorrect object type for target in RemoveFavoriteItem. Expected Types: HxFavoriteItem");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(476, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.removeFavoritePerson = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxFavoritePerson) {
                throw new Error("Incorrect object type for target in RemoveFavoritePerson. Expected Types: HxFavoritePerson");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(478, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.removeFavoritePersonWithUndo = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxFavoritePerson) {
                throw new Error("Incorrect object type for target in RemoveFavoritePerson. Expected Types: HxFavoritePerson");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(478, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.removeFavoriteView = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxView) {
                throw new Error("Incorrect object type for target in RemoveFavoriteView. Expected Types: HxView");
            }
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(479, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeFavoriteViewWithUndo = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxView) {
                throw new Error("Incorrect object type for target in RemoveFavoriteView. Expected Types: HxView");
            }
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(479, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeFromCalendar = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in RemoveFromCalendar. Expected Types: HxMessageHeader");
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(101, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeFromCalendarByMessageServerId = function (targetId, actorCompletionNotificationType) {
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runServerIdTargetActor(552, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.removeMessageSignerEncryptionCertificateFromLocalCache = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in RemoveMessageSignerEncryptionCertificateFromLocalCache. Expected Types: HxMessageHeader");
        }
        return this.runActor(592, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.removePresenceObservers = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RemovePresenceObservers. Expected Types: HxAccount");
        }
        var serialized_args = HxPresenceArgs_1.serializeHxPresenceArgs(args);
        return this.runActor(635, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.removeRecipient = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxPerson) {
            throw new Error("Incorrect object type for target in RemoveRecipient. Expected Types: HxPerson");
        }
        return this.runActor(226, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.renameView = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in RenameView. Expected Types: HxView");
        }
        var serialized_args = HxRenameViewArgs_1.serializeHxRenameViewArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(208, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.renameViewWithUndo = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in RenameView. Expected Types: HxView");
        }
        var serialized_args = HxRenameViewArgs_1.serializeHxRenameViewArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActorWithUndo(208, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.reParentDraft = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in ReParentDraft. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxReParentDraftArgs_1.serializeHxReParentDraftArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(350, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * ReplyAllToAppointment
    * @param draftBody Contains the HTML body as well as if we should pass the body as smartReply or not. If null, it will leave the existing value.
    */
    HxActorAPIs.prototype.replyAllToAppointment = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in ReplyAllToAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxCreateMeetingReplyArgs_1.serializeHxCreateMeetingReplyArgs(args);
        return this.runActorWithResultsAsync(375, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * ReplyAllToMessage
    * @param draftBody Contains the HTML body as well as isFirstBody to determine if we should pass the body as smartReply or not.
    */
    HxActorAPIs.prototype.replyAllToMessage = function (targetId, args, actorCompletionNotificationType) {
        if (!targetId[0].isNil() && targetId[0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for first item of the Pair Target in ReplyAllToMessage. Expected ConversationHeader");
        }
        if (!targetId[1].isNil() && targetId[1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for second item of the Pair Target in ReplyAllToMessage. Expected MessageHeader");
        }
        var serialized_args = HxCreateReplyDraftArgs_1.serializeHxCreateReplyDraftArgs(args);
        return this.runPairTargetActorWithResultsAsync(217, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * ReplyToAppointment
    * @param draftBody Contains the HTML body as well as if we should pass the body as smartReply or not. If null, it will leave the existing value.
    */
    HxActorAPIs.prototype.replyToAppointment = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in ReplyToAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxCreateMeetingReplyArgs_1.serializeHxCreateMeetingReplyArgs(args);
        return this.runActorWithResultsAsync(374, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * ReplyToMessage
    * @param draftBody Contains the HTML body as well as isFirstBody to determine if we should pass the body as smartReply or not.
    */
    HxActorAPIs.prototype.replyToMessage = function (targetId, args, actorCompletionNotificationType) {
        if (!targetId[0].isNil() && targetId[0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for first item of the Pair Target in ReplyToMessage. Expected ConversationHeader");
        }
        if (!targetId[1].isNil() && targetId[1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for second item of the Pair Target in ReplyToMessage. Expected MessageHeader");
        }
        var serialized_args = HxCreateReplyDraftArgs_1.serializeHxCreateReplyDraftArgs(args);
        return this.runPairTargetActorWithResultsAsync(216, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    /**
    * ReportAbuse: Along with reporting the target, this actor will also move the target into the Junk folder.
    */
    HxActorAPIs.prototype.reportAbuse = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in ReportAbuse. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxReportAbuseArgs_1.serializeHxReportAbuseArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(806, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.reportAutoDetectFeedback = function (args, actorCompletionNotificationType) {
        var serialized_args = HxReportAutoDetectFeedbackArgs_1.serializeHxReportAutoDetectFeedbackArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(624, [], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.reportLegacyCalendarSearchInstrumentation = function (args, actorCompletionNotificationType) {
        var serialized_args = HxReportSearchInstrumentationArgs_1.serializeHxReportSearchInstrumentationArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(663, [], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.reportSearchFeedback = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in ReportSearchFeedback. Expected Types: HxSearchSession");
        }
        var serialized_args = HxReportSearchFeedbackArgs_1.serializeHxReportSearchFeedbackArgs(args);
        return this.runActorWithResultsAsync(371, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.reportSearchInstrumentation = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in ReportSearchInstrumentation. Expected Types: HxSearchSession");
        }
        var serialized_args = HxReportSearchInstrumentationArgs_1.serializeHxReportSearchInstrumentationArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(307, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.requestDeliveryReceipt = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in RequestDeliveryReceipt. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(579, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.requestReadReceipt = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in RequestReadReceipt. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(578, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * RequestSearchSuggestions
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    * @param allowOffline When true, allows offline lookup of people suggestions
    * @param timeoutToOfflineSearchFallback Set a non-zero timeout to enable HxCore to fall back to offline search automatically if online search fails/timeouts. Otherwise, pass nullopt.
    */
    HxActorAPIs.prototype.requestSearchSuggestions = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in RequestSearchSuggestions. Expected Types: HxSearchSession");
        }
        var serialized_args = HxRequestSearchSuggestionsArgs_1.serializeHxRequestSearchSuggestionsArgs(args);
        return this.runActorWithResultsAsync(278, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.resetAccount = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in ResetAccount. Expected Types: HxAccount");
        }
        return this.runActor(409, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.resetCalendarFeedsCatalog = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in ResetCalendarFeedsCatalog. Expected Types: HxAccount");
        }
        return this.runActor(177, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.resolveAttachmentInlineStatus = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in ResolveAttachmentInlineStatus. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxResolveAttachmentInlineStatusArgs_1.serializeHxResolveAttachmentInlineStatusArgs(args);
        return this.runActor(169, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.resolveLocalRecipients = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in ResolveLocalRecipients. Expected Types: HxAccount");
        }
        var serialized_args = HxResolveLocalRecipientsArgs_1.serializeHxResolveLocalRecipientsArgs(args);
        return this.runActorWithResultsAsync(673, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.resolveRecipient = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxPerson) {
            throw new Error("Incorrect object type for target in ResolveRecipient. Expected Types: HxPerson");
        }
        return this.runActor(229, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.resolveSearchEntities = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in ResolveSearchEntities. Expected Types: HxSearchSession");
        }
        var serialized_args = HxResolveSearchEntitiesArgs_1.serializeHxResolveSearchEntitiesArgs(args);
        return this.runActor(770, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * RespondToCalendarEvent
    * @param proposedStartTime Used only for the ProposeNewTime feature. Can be ignored otherwise.
    * @param proposedEndTime Used only for the ProposeNewTime feature. Can be ignored otherwise.
    * @param subject Localized string to use for response email title for DirectSync. If not populated, meeting title will be used.
    */
    HxActorAPIs.prototype.respondToCalendarEvent = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in RespondToCalendarEvent. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxMeetingResponseArgs_1.serializeHxMeetingResponseArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(72, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * RespondToMeetingRequest
    * @param proposedStartTime Used only for the ProposeNewTime feature. Can be ignored otherwise.
    * @param proposedEndTime Used only for the ProposeNewTime feature. Can be ignored otherwise.
    * @param subject Localized string to use for response email title for DirectSync. If not populated, meeting title will be used.
    */
    HxActorAPIs.prototype.respondToMeetingRequest = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for target in RespondToMeetingRequest. Expected Types: HxMessageHeader");
            }
        }
        var serialized_args = HxMeetingResponseArgs_1.serializeHxMeetingResponseArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(22, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * RespondToMeetingRequestByServerId
    * @param proposedStartTime Used only for the ProposeNewTime feature. Can be ignored otherwise.
    * @param proposedEndTime Used only for the ProposeNewTime feature. Can be ignored otherwise.
    * @param subject Localized string to use for response email title for DirectSync. If not populated, meeting title will be used.
    */
    HxActorAPIs.prototype.respondToMeetingRequestByServerId = function (targetId, args, actorCompletionNotificationType) {
        var serialized_args = HxMeetingResponseArgs_1.serializeHxMeetingResponseArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runServerIdTargetActor(497, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.respondToOneRMContent = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RespondToOneRMContent. Expected Types: HxAccount");
        }
        var serialized_args = HxRespondToOneRMContentArgs_1.serializeHxRespondToOneRMContentArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(301, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * ResumeHxCore: This actor is used to notify Hx that Application is resuming
    */
    HxActorAPIs.prototype.resumeHxCore = function (args) {
        var serialized_args = HxResumeHxCoreArgs_1.serializeHxResumeHxCoreArgs(args);
        return this.runActor(675, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.retrieveCertificateInfo = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in RetrieveCertificateInfo. Expected Types: HxAccount");
        }
        var serialized_args = HxRetrieveCertificateInfoArgs_1.serializeHxRetrieveCertificateInfoArgs(args);
        return this.runActorWithResultsAsync(647, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.saveAliasPreference = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SaveAliasPreference. Expected Types: HxAccount");
        }
        var serialized_args = HxSaveAliasPreferenceArgs_1.serializeHxSaveAliasPreferenceArgs(args);
        return this.runActor(242, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveAsEMLFile = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SaveAsEMLFile. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSaveAsEMLFileArgs_1.serializeHxSaveAsEMLFileArgs(args);
        return this.runActor(576, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SaveDraft
    * @param subject If not null, this will set the subject in the draft's MessageHeader. If null, it will leave the existing value.
    * @param preview If not null, this will set the body preview in the draft's MessageHeader. If null, it will leave the existing value. In S/MIME, this is ignored, and the preview will be set as empty instead. If the account doesn't SupportMessagePreviewGeneration, this is ignored, and the preview won't be set.
    * @param draftBody Contains the HTML body as well as if we should pass the body as smartReply or not. If null, it will leave the existing value.
    * @param alternatePlainTextBody Only used for S/MIME, this is used to add an alternative Plain text body to the MIME generated when generating the S/MIME attachment. It is ignored otherwise.
    * @param isSigned If not null, this will indicate if the message should be SMIME signed. If null, it will leave the existing value.
    * @param isEncrypted If not null, this will indicate if the message should be SMIME signed. If null, it will leave the existing value.
    * @param isSmimeRemoveAndSend In S/MIME, if true, this will remove recipients that don't have a valid certificate before sending the message.
    */
    HxActorAPIs.prototype.saveDraft = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SaveDraft. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSaveDraftArgs_1.serializeHxSaveDraftArgs(args);
        return this.runActorWithResultsAsync(6, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.saveGlobalApplicationApplyAllPreferences = function (args) {
        var serialized_args = HxSaveGlobalApplicationApplyAllPreferencesArgs_1.serializeHxSaveGlobalApplicationApplyAllPreferencesArgs(args);
        return this.runActor(363, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveGlobalApplicationDaysToPrescheduleReminders = function (args) {
        var serialized_args = HxSaveGlobalApplicationDaysToPrescheduleRemindersArgs_1.serializeHxSaveGlobalApplicationDaysToPrescheduleRemindersArgs(args);
        return this.runActor(450, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveGlobalApplicationDefaultFontPreferences = function (args) {
        var serialized_args = HxSaveGlobalApplicationDefaultFontPreferencesArgs_1.serializeHxSaveGlobalApplicationDefaultFontPreferencesArgs(args);
        return this.runActor(553, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveGlobalApplicationExternalContentPreferences = function (args) {
        var serialized_args = HxSaveGlobalApplicationExternalContentPreferencesArgs_1.serializeHxSaveGlobalApplicationExternalContentPreferencesArgs(args);
        return this.runActor(194, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveGlobalApplicationMarkAsReadSetting = function (args) {
        var serialized_args = HxSaveGlobalApplicationMarkAsReadSettingArgs_1.serializeHxSaveGlobalApplicationMarkAsReadSettingArgs(args);
        return this.runActor(266, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveGlobalApplicationPersonalizationSettings = function (args, actorCompletionNotificationType) {
        var serialized_args = HxSaveGlobalApplicationPersonalizationSettingsArgs_1.serializeHxSaveGlobalApplicationPersonalizationSettingsArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(212, [], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.saveGlobalApplicationQuickActionsPreferences = function (args) {
        var serialized_args = HxSaveGlobalApplicationQuickActionsPreferencesArgs_1.serializeHxSaveGlobalApplicationQuickActionsPreferencesArgs(args);
        return this.runActor(192, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveGlobalApplicationSettingByPropertyID = function (args) {
        var serialized_args = HxSaveGlobalApplicationSettingByPropertyIDArgs_1.serializeHxSaveGlobalApplicationSettingByPropertyIDArgs(args);
        return this.runActor(211, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SaveGlobalApplicationSignaturePreferences
    * @param signatureImages contentId|filename
    */
    HxActorAPIs.prototype.saveGlobalApplicationSignaturePreferences = function (args) {
        var serialized_args = HxSaveGlobalApplicationSignaturePreferencesArgs_1.serializeHxSaveGlobalApplicationSignaturePreferencesArgs(args);
        return this.runActor(195, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.saveGlobalApplicationTimeZoneId = function (args) {
        var serialized_args = HxSaveGlobalApplicationTimeZoneIdArgs_1.serializeHxSaveGlobalApplicationTimeZoneIdArgs(args);
        return this.runActor(550, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * ScheduleMailItem
    * @param scheduledReturnTime Not used when unSchedule is true, else it is required.
    */
    HxActorAPIs.prototype.scheduleMailItem = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in ScheduleMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in ScheduleMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxScheduleMailItemArgs_1.serializeHxScheduleMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(432, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * ScheduleMailItem
    * @param scheduledReturnTime Not used when unSchedule is true, else it is required.
    */
    HxActorAPIs.prototype.scheduleMailItemWithUndo = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in ScheduleMailItem. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in ScheduleMailItem. Expected MessageHeader");
            }
        }
        var serialized_args = HxScheduleMailItemArgs_1.serializeHxScheduleMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActorWithUndo(432, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * ScheduleMailItemByServerId
    * @param scheduledReturnTime Not used when unSchedule is true, else it is required.
    */
    HxActorAPIs.prototype.scheduleMailItemByServerId = function (targetIds, args, actorCompletionNotificationType) {
        var serialized_args = HxScheduleMailItemArgs_1.serializeHxScheduleMailItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(433, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * SearchAnswers
    * @param entities Key/Value payload for AnswerEntities and Actions consisting of a Key identifying the entity and its JSON payload
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    */
    HxActorAPIs.prototype.searchAnswers = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchAnswers. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchAnswersArgs_1.serializeHxSearchAnswersArgs(args);
        return this.runActor(697, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.searchAttachments = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchAttachments. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchAttachmentsArgs_1.serializeHxSearchAttachmentsArgs(args);
        return this.runActor(439, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SearchAttachmentsNextPage
    * @param maxResultsRequested When setting it to 0, HxCore will use the parameter of the first page search request.
    */
    HxActorAPIs.prototype.searchAttachmentsNextPage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchAttachmentsNextPage. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchNextPageArgs_1.serializeHxSearchNextPageArgs(args);
        return this.runActor(705, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SearchCalendar
    * @param skipHistory Set to true if query is from people suggestion, rather than user typed query or a text suggestion. 3S will skip adding query to search history.
    * @param timeRange Time range must be in UTC
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    * @param timeoutToOfflineSearchFallback Set a non-zero timeout to enable HxCore to fall back to offline search automatically if online search fails/timeouts. Otherwise, pass nullopt.
    */
    HxActorAPIs.prototype.searchCalendar = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchCalendar. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchCalendarArgs_1.serializeHxSearchCalendarArgs(args);
        return this.runActor(334, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SearchCalendarLegacy
    * @param isMultiAccountRequest When nullopt, true if there is more than one eligible account
    * @param timeRange Time range must be in UTC
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    */
    HxActorAPIs.prototype.searchCalendarLegacy = function (args) {
        var serialized_args = HxSearchCalendarLegacyArgs_1.serializeHxSearchCalendarLegacyArgs(args);
        return this.runActorWithResultsAsync(616, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.searchContacts = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SearchContacts. Expected Types: HxAccount");
        }
        var serialized_args = HxSearchContactsArgs_1.serializeHxSearchContactsArgs(args);
        return this.runActorWithResultsAsync(254, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * SearchFiles
    * @param skipHistory Set to true if query is from people suggestion, rather than user typed query or a text suggestion. 3S will skip adding query to search history.
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    */
    HxActorAPIs.prototype.searchFiles = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchFiles. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchFilesArgs_1.serializeHxSearchFilesArgs(args);
        return this.runActor(782, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SearchFilesNextPage
    * @param maxResultsRequested When setting it to 0, HxCore will use the parameter of the first page search request.
    */
    HxActorAPIs.prototype.searchFilesNextPage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchFilesNextPage. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchNextPageArgs_1.serializeHxSearchNextPageArgs(args);
        return this.runActor(783, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.searchForMessageHeadersInConversation = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for target in SearchForMessageHeadersInConversation. Expected Types: HxConversationHeader");
        }
        var serialized_args = HxSearchForMessageHeadersInConversationArgs_1.serializeHxSearchForMessageHeadersInConversationArgs(args);
        return this.runActor(339, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.searchLocalContacts = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SearchLocalContacts. Expected Types: HxAccount");
        }
        var serialized_args = HxSearchLocalContactsArgs_1.serializeHxSearchLocalContactsArgs(args);
        return this.runActorWithResultsAsync(470, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * SearchMail
    * @param viewId The view to search for JustThisFolder search, or the view to fallback to when AllFolders search is not supported. If nullopt, use the inbox
    * @param requestAlteration Request alteration for natural language search query
    * @param isMultiAccountRequest When nullopt, true if the UnifiedMailbox has more than one account
    * @param skipHistory Set to true if query is from people suggestion, rather than user typed query or a text suggestion. 3S will skip adding query to search history.
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    * @param timeoutToOfflineSearchFallback Set a non-zero timeout to enable HxCore to fall back to offline search automatically if online search fails/timeouts. Otherwise, pass nullopt
    */
    HxActorAPIs.prototype.searchMail = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchMail. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchMailArgs_1.serializeHxSearchMailArgs(args);
        return this.runActorWithResultsAsync(277, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * SearchMailNextPage
    * @param maxResultsRequested When setting it to 0, HxCore will use the parameter of the first page search request.
    */
    HxActorAPIs.prototype.searchMailNextPage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchMailNextPage. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchNextPageArgs_1.serializeHxSearchNextPageArgs(args);
        return this.runActorWithResultsAsync(707, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * SearchPeople
    * @param skipHistory Set to true if query is from people suggestion, rather than user typed query or a text suggestion. 3S will skip adding query to search history.
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    * @param timeoutToOfflineSearchFallback Set a non-zero timeout to enable HxCore to fall back to offline search automatically if online search fails/timeouts. Otherwise, pass nullopt.
    */
    HxActorAPIs.prototype.searchPeople = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchPeople. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchPeopleArgs_1.serializeHxSearchPeopleArgs(args);
        return this.runActor(379, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.searchPeopleForAddressing = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SearchPeopleForAddressing. Expected Types: HxAccount");
        }
        var serialized_args = HxSearchPeopleForAddressingArgs_1.serializeHxSearchPeopleForAddressingArgs(args);
        return this.runActorWithResultsAsync(719, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    /**
    * SearchPeopleNextPage
    * @param maxResultsRequested When setting it to 0, HxCore will use the parameter of the first page search request.
    */
    HxActorAPIs.prototype.searchPeopleNextPage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchPeopleNextPage. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchNextPageArgs_1.serializeHxSearchNextPageArgs(args);
        return this.runActor(709, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.searchRecentAttachments = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchRecentAttachments. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchRecentAttachmentsArgs_1.serializeHxSearchRecentAttachmentsArgs(args);
        return this.runActor(446, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SearchRecipientByKeystroke
    * @param senderAccountId This is the active or sender account from which mail or event is being composed.
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    * @param timeoutToOfflineSearchFallback Set a non-zero timeout to enable HxCore to fall back to offline search automatically if online search fails/timeouts. Otherwise, pass nullopt.
    */
    HxActorAPIs.prototype.searchRecipientByKeystroke = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchRecipientByKeystroke. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchRecipientByKeystrokeArgs_1.serializeHxSearchRecipientByKeystrokeArgs(args);
        return this.runActor(778, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SearchTop
    * @param answerEntities Key/Value payload for Answers, Ranking, and Actions consisting of a Key identifying the entity and its JSON payload
    * @param requestAlteration Request alteration for natural language search query
    * @param logicalId A GUID that should be shared between requests if they are issued at the same time in the client UI.
    * @param searchConversationIdFor3S A GUID that maps to 3S conversationId.
    * @param timeoutToOfflineSearchFallback Set a non-zero timeout to enable HxCore to fall back to offline search automatically if online search fails/timeouts. Otherwise, pass nullopt.
    */
    HxActorAPIs.prototype.searchTop = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchTop. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchTopArgs_1.serializeHxSearchTopArgs(args);
        return this.runActor(717, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.searchTopNextPage = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxSearchSession) {
            throw new Error("Incorrect object type for target in SearchTopNextPage. Expected Types: HxSearchSession");
        }
        var serialized_args = HxSearchTopNextPageArgs_1.serializeHxSearchTopNextPageArgs(args);
        return this.runActor(801, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.send = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in Send. Expected Types: HxMessageHeader");
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(14, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.sendReadReceipt = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SendReadReceipt. Expected Types: HxMessageHeader");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(584, [targetId], '[]', completionNotificationType);
    };
    /**
    * SetAccountCertificatesOrder: set account certificate orders: Contacts, GAL, Local, LDAP, etc
    */
    HxActorAPIs.prototype.setAccountCertificatesOrder = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetAccountCertificatesOrder. Expected Types: HxAccount");
        }
        var serialized_args = HxSetAccountCertificateOrderListArgs_1.serializeHxSetAccountCertificateOrderListArgs(args);
        return this.runActor(771, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SetAccountLDAPServerSettingList: LDAP paths
    */
    HxActorAPIs.prototype.setAccountLDAPServerSettingList = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetAccountLDAPServerSettingList. Expected Types: HxAccount");
        }
        var serialized_args = HxSetAccountLDAPServerSettingListArgs_1.serializeHxSetAccountLDAPServerSettingListArgs(args);
        return this.runActor(772, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setAccountPreference = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetAccountPreference. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetAccountPreferenceArgs_1.serializeHxSetAccountPreferenceArgs(args);
        return this.runActor(175, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SetAddInRoamingSettings
    * @param roamingSettings Json representing the roaming settings of the AddIn denoted by addInId
    */
    HxActorAPIs.prototype.setAddInRoamingSettings = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetAddInRoamingSettings. Expected Types: HxAccount");
        }
        var serialized_args = HxSetAddInRoamingSettingsArgs_1.serializeHxSetAddInRoamingSettingsArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(687, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setAllowSMIMECertificatesWithoutMatchingEmailAddress = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetAllowSMIMECertificatesWithoutMatchingEmailAddress. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(728, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setAlwaysEncrypt = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetAlwaysEncrypt. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(394, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setAlwaysSign = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetAlwaysSign. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(393, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setBadgeCountPushNotificationInfo = function (args) {
        var serialized_args = HxSetBadgeCountPushNotificationInfoArgs_1.serializeHxSetBadgeCountPushNotificationInfoArgs(args);
        return this.runActor(417, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setCalendarDefaultReminderTime = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetCalendarDefaultReminderTime. Expected Types: HxAccount");
        }
        var serialized_args = HxSetCalendarDefaultReminderTimeArgs_1.serializeHxSetCalendarDefaultReminderTimeArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(507, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setClearSignSignedMessages = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetClearSignSignedMessages. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(606, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setConversationHeaderLastAccessedTime = function (targetId) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
            throw new Error("Incorrect object type for target in SetConversationHeaderLastAccessedTime. Expected Types: HxConversationHeader");
        }
        return this.runActor(327, [targetId], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setConversationViewMode = function (args) {
        var serialized_args = HxSetConversationViewModeArgs_1.serializeHxSetConversationViewModeArgs(args);
        return this.runActor(47, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SetCustomPropertiesOnAppointment
    * @param customProperties Json representing how the AddIn denoted by addInId has affected this (the target) item
    */
    HxActorAPIs.prototype.setCustomPropertiesOnAppointment = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in SetCustomPropertiesOnAppointment. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxSetCustomPropertiesOnItemArgs_1.serializeHxSetCustomPropertiesOnItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(679, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * SetCustomPropertiesOnMessage
    * @param customProperties Json representing how the AddIn denoted by addInId has affected this (the target) item
    */
    HxActorAPIs.prototype.setCustomPropertiesOnMessage = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetCustomPropertiesOnMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetCustomPropertiesOnItemArgs_1.serializeHxSetCustomPropertiesOnItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(680, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setDefaultFontHtml = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetDefaultFontHtml. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetDefaultFontHtmlArgs_1.serializeHxSetDefaultFontHtmlArgs(args);
        return this.runActor(543, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setDraftHighPriority = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetDraftHighPriority. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetDraftPriorityArgs_1.serializeHxSetDraftPriorityArgs(args);
        return this.runActor(128, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setDraftLowPriority = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetDraftLowPriority. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetDraftPriorityArgs_1.serializeHxSetDraftPriorityArgs(args);
        return this.runActor(129, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setDraftPriority = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetDraftPriority. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetDraftPriorityArgs_1.serializeHxSetDraftPriorityArgs(args);
        return this.runActor(123, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setDraftSenderEmail = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetDraftSenderEmail. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetDraftSenderEmailArgs_1.serializeHxSetDraftSenderEmailArgs(args);
        return this.runActor(213, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setEncryptingAlgorithm = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetEncryptingAlgorithm. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetEncryptingAlgorithmArgs_1.serializeHxSetEncryptingAlgorithmArgs(args);
        return this.runActor(605, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setEncryptingCertificate = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetEncryptingCertificate. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxCertificateArgs_1.serializeHxCertificateArgs(args);
        return this.runActor(603, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setEncryptingCertificateHash = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetEncryptingCertificateHash. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetEncryptingCertificateHashArgs_1.serializeHxSetEncryptingCertificateHashArgs(args);
        return this.runActor(396, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setFirstBodyByteOffset = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetFirstBodyByteOffset. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetFirstBodyByteOffsetArgs_1.serializeHxSetFirstBodyByteOffsetArgs(args);
        return this.runActor(348, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setFirstDayOfWeek = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetFirstDayOfWeek. Expected Types: HxAccount");
        }
        var serialized_args = HxSetFirstDayOfWeekArgs_1.serializeHxSetFirstDayOfWeekArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(732, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setIncludeChainCertsInMessage = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetIncludeChainCertsInMessage. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(612, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SetInternetHeadersOnMessage
    * @param headers header|value
    */
    HxActorAPIs.prototype.setInternetHeadersOnMessage = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetInternetHeadersOnMessage. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetInternetHeadersOnMessageArgs_1.serializeHxSetInternetHeadersOnMessageArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(796, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setIsDraftEncrypted = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetIsDraftEncrypted. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetIsDraftEncryptedArgs_1.serializeHxSetIsDraftEncryptedArgs(args);
        return this.runActorWithResultsAsync(161, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.setIsDraftSigned = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetIsDraftSigned. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetIsDraftSignedArgs_1.serializeHxSetIsDraftSignedArgs(args);
        return this.runActorWithResultsAsync(160, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.setIsDraftSignedAndEncrypted = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetIsDraftSignedAndEncrypted. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActorWithResultsAsync(640, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.setIsExternalContentEnabled = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetIsExternalContentEnabled. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(392, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setIsFocusedInboxEnabled = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetIsFocusedInboxEnabled. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetIsFocusedInboxEnabledArgs_1.serializeHxSetIsFocusedInboxEnabledArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(255, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setIsSignatureEnabled = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetIsSignatureEnabled. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(383, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setIsSignatureUserModified = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetIsSignatureUserModified. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(384, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setIsSMIMEExternalContentEnabled = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetIsSMIMEExternalContentEnabled. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(465, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setIsSyncEnabledForView = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxView) {
                throw new Error("Incorrect object type for target in SetIsSyncEnabledForView. Expected Types: HxView");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(173, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setIsWorkingOffline = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetIsWorkingOffline. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(568, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setMessageClassification = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in SetMessageClassification. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in SetMessageClassification. Expected MessageHeader");
            }
        }
        var serialized_args = HxSetMessageClassificationArgs_1.serializeHxSetMessageClassificationArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(264, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setMipLabel = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetMipLabel. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetMipLabelArgs_1.serializeHxSetMipLabelArgs(args);
        return this.runActor(554, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setOnlineMeetingsByDefaultEnabled = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetOnlineMeetingsByDefaultEnabled. Expected Types: HxAccount");
        }
        var serialized_args = HxSetOnlineMeetingsByDefaultEnabledArgs_1.serializeHxSetOnlineMeetingsByDefaultEnabledArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(729, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setPreselectedMoveToViewsPrimary = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetPreselectedMoveToViewsPrimary. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetPreselectedMoveToViewsPrimaryArgs_1.serializeHxSetPreselectedMoveToViewsPrimaryArgs(args);
        return this.runActor(397, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setPreselectedMoveToViewsSecondary = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetPreselectedMoveToViewsSecondary. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetPreselectedMoveToViewsSecondaryArgs_1.serializeHxSetPreselectedMoveToViewsSecondaryArgs(args);
        return this.runActor(398, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setPushNotificationSettings = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetPushNotificationSettings. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetPushNotificationSettingsArgs_1.serializeHxSetPushNotificationSettingsArgs(args);
        return this.runActor(416, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setPushNotificationToken = function (args) {
        var serialized_args = HxSetPushNotificationTokenArgs_1.serializeHxSetPushNotificationTokenArgs(args);
        return this.runActor(366, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setQuickActionPrimary = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetQuickActionPrimary. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetQuickActionPrimaryArgs_1.serializeHxSetQuickActionPrimaryArgs(args);
        return this.runActor(386, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setQuickActionSecondary = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetQuickActionSecondary. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetQuickActionSecondaryArgs_1.serializeHxSetQuickActionSecondaryArgs(args);
        return this.runActor(387, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setRecipients = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SetRecipients. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxSetRecipientsArgs_1.serializeHxSetRecipientsArgs(args);
        return this.runActorWithResultsAsync(571, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.setReminderTimeForCloudCacheDialog = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetReminderTimeForCloudCacheDialog. Expected Types: HxAccount");
        }
        var serialized_args = HxSetReminderTimeForCloudCacheDialogArgs_1.serializeHxSetReminderTimeForCloudCacheDialogArgs(args);
        return this.runActor(575, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setServerUndoState = function (args) {
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(581, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SetSignatureHtml
    * @param signatureImages contentId|filename
    */
    HxActorAPIs.prototype.setSignatureHtml = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetSignatureHtml. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetSignatureHtmlArgs_1.serializeHxSetSignatureHtmlArgs(args);
        return this.runActor(385, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setSigningAlgorithm = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetSigningAlgorithm. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetSigningAlgorithmArgs_1.serializeHxSetSigningAlgorithmArgs(args);
        return this.runActor(604, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setSigningCertificate = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetSigningCertificate. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxCertificateArgs_1.serializeHxCertificateArgs(args);
        return this.runActor(602, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setSigningCertificateHash = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetSigningCertificateHash. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetSigningCertificateHashArgs_1.serializeHxSetSigningCertificateHashArgs(args);
        return this.runActor(395, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SetSpeedyMeetingSetting
    * @param clipLongMeetingBy End longer appointments and meetings early by the specified minutes
    * @param clipShortMeetingBy End shorter appointments and meetings early by the specified minutes
    * @param clippingType Is end-early/start-late for appointments and meetings enabled
    */
    HxActorAPIs.prototype.setSpeedyMeetingSetting = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetSpeedyMeetingSetting. Expected Types: HxAccount");
        }
        var serialized_args = HxSetSpeedyMeetingSettingArgs_1.serializeHxSetSpeedyMeetingSettingArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(730, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * SetSubfoldersTreeExpanded: Updates View::SubfoldersTreeExpanded. App should call when user expands or collapses
                      a view on the navpane to persist the collapsed state.
    */
    HxActorAPIs.prototype.setSubfoldersTreeExpanded = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in SetSubfoldersTreeExpanded. Expected Types: HxView");
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(547, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setTeachingStatus = function (targetIds, args) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in SetTeachingStatus. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxSetTeachingStatusArgs_1.serializeHxSetTeachingStatusArgs(args);
        return this.runActor(281, targetIds, JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.setViewLastAccessedTime = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxView) {
                throw new Error("Incorrect object type for target in SetViewLastAccessedTime. Expected Types: HxView");
            }
        }
        var serialized_args = [];
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(168, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.setViewSortMode = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in SetViewSortMode. Expected Types: HxView");
        }
        var serialized_args = HxSetViewSortModeArgs_1.serializeHxSetViewSortModeArgs(args);
        return this.runActor(268, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * SetWeekNumberSetting
    * @param FirstWeekOfYear Week numbers are counted based on how the first week is identified
    */
    HxActorAPIs.prototype.setWeekNumberSetting = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SetWeekNumberSetting. Expected Types: HxAccount");
        }
        var serialized_args = HxSetWeekNumberSettingArgs_1.serializeHxSetWeekNumberSettingArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(733, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * SimulatedWatermarkPushNotification: Used to trigger background sync for accounts that do not receive server push notifications.
    */
    HxActorAPIs.prototype.simulatedWatermarkPushNotification = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in SimulatedWatermarkPushNotification. Expected Types: HxAccount");
        }
        var serialized_args = HxSimulatedWatermarkPushNotificationArgs_1.serializeHxSimulatedWatermarkPushNotificationArgs(args);
        return this.runActorWithResultsAsync(536, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.snoozeReminder = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in SnoozeReminder. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxSnoozeReminderArgs_1.serializeHxSnoozeReminderArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(451, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.sortContacts = function (args) {
        var serialized_args = HxSortContactsArgs_1.serializeHxSortContactsArgs(args);
        return this.runActor(748, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.startStorageMaintenance = function () {
        return this.runActor(376, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.stopStorageMaintenance = function () {
        return this.runActor(377, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.suppressReadReceipt = function (targetId, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in SuppressReadReceipt. Expected Types: HxMessageHeader");
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(585, [targetId], '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.syncAccounts = function () {
        return this.runActor(91, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.turnOffAutoReply = function (targetIds, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in TurnOffAutoReply. Expected Types: HxAccount");
            }
        }
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(158, targetIds, '[]', completionNotificationType);
    };
    HxActorAPIs.prototype.turnOnAutoReply = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxAccount) {
                throw new Error("Incorrect object type for target in TurnOnAutoReply. Expected Types: HxAccount");
            }
        }
        var serialized_args = HxTurnOnAutoReplyArgs_1.serializeHxTurnOnAutoReplyArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(360, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.uninstallAddIn = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in UninstallAddIn. Expected Types: HxAccount");
        }
        var serialized_args = HxAddInInfoArgs_1.serializeHxAddInInfoArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(654, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.unpinView = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxView) {
            throw new Error("Incorrect object type for target in UnpinView. Expected Types: HxView");
        }
        var serialized_args = HxTileIdArgs_1.serializeHxTileIdArgs(args);
        return this.runActor(203, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.unsubscribeFromMailingList = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (!targetIds[i][0].isNil() && targetIds[i][0].getObjectType() !== HxObjectType_1.default.HxConversationHeader) {
                throw new Error("Incorrect object type for first item of the Pair Target in UnsubscribeFromMailingList. Expected ConversationHeader");
            }
            if (!targetIds[i][1].isNil() && targetIds[i][1].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for second item of the Pair Target in UnsubscribeFromMailingList. Expected MessageHeader");
            }
        }
        var serialized_args = HxUnsubscribeFromMailingListArgs_1.serializeHxUnsubscribeFromMailingListArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runPairTargetActor(378, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateAccount
    * @param userDisplayName This propertry is supported for those account types which do not return user’s full name from the provider.
    * @param incomingServerPort For DirectSync; IMAP/POP server port. When setIncomingServerProperties is set, clients must provide incomingServerPort. Otherwise updateAccount actor will fail with precondition violated exception.
    * @param setOutgoingServerProperties For DirectSync; smtp server configuration. If this is set, client must provide all of outgoingServerAddress, outgoingServerPort and outgoingServerSslScheme.
    * @param outgoingServerAuthenticationRequired For DirectSync; indicate if outgoing server requires authentication. Must be provided if setOutgoingServerProperties is true
    * @param outgoingServerAddress For DirectSync; smtp server. If setOutgoingServerProperties is set clients must provide this value. Otherwise actor will fail with preconditions violated exception.
    * @param outgoingServerPort For DirectSync; smtp port. If setOutgoingServerProperties is set clients must provide a non-zero value. Otherwise actor will fail with preconditions violated exception.
    * @param outgoingServerSslScheme For DirectSync; smtps. If setOutgoingServerProperties is set clients must provide this value. Otherwise actor will fail with preconditions violated exception.
    * @param popLeaveOnServer for pop accounts only; false: messages are deleted after downloading them from server, true: messages are left in the server, ignored/not-used on non-pop accounts
    * @param sslCertificateValidation for directsync/imapcc/mopcc/uopcc accounts only; Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.updateAccount = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in UpdateAccount. Expected Types: HxAccount");
        }
        var serialized_args = HxUpdateAccountArgs_1.serializeHxUpdateAccountArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(231, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(231, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(231, JSON.parse(failureresults))); }); });
    };
    /**
    * UpdateAccountCredentials
    * @param incomingServerPassword For basic auth. Password for accessing server for incoming data (eg Imap server)
    * @param outgoingServerUserName Relevant for IMAP-CC and DirectSync accounts only. For IMAP-CC account will not be updated for username. DirectSync will.
    * @param outgoingServerPassword Relevant for IMAP-CC and DirectSync basic auth. Passowrd will be updated for both IMAP-CC and DirectSync accounts
    * @param sslCertificateValidation Default: client will only connect if the server's ssl certificates are valid, Disabled: if there are no fatal ssl certificate issues client will connect to the server.
    */
    HxActorAPIs.prototype.updateAccountCredentials = function (targetId, args) {
        var _this = this;
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in UpdateAccountCredentials. Expected Types: HxAccount");
        }
        var serialized_args = HxUpdateAccountCredentialsArgs_1.serializeHxUpdateAccountCredentialsArgs(args);
        return new Promise(function (resolve, reject) { _this.runActorWithCustomFailureResults(356, [targetId], JSON.stringify(serialized_args)).then(function (results) { return resolve(HxActorAPIs.deserializeResults(356, results)); }).catch(function (failureresults) { return reject(HxFailureResultsWithData_1.HxFailureResultsWithData.deserialize(356, JSON.parse(failureresults))); }); });
    };
    HxActorAPIs.prototype.updateBackgroundImageDarkness = function (args) {
        var serialized_args = HxSaveBackgroundImageAnalysisResultArgs_1.serializeHxSaveBackgroundImageAnalysisResultArgs(args);
        return this.runActor(353, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateBackgroundRevision = function () {
        return this.runActor(171, [], '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateBatteryStatus = function (args) {
        var serialized_args = HxUpdateBatteryStatusArgs_1.serializeHxUpdateBatteryStatusArgs(args);
        return this.runActor(402, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * UpdateCalendar
    * @param calendarName If populated and the calendar has write permissions, the calendar will be renamed to the given name
    */
    HxActorAPIs.prototype.updateCalendar = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in UpdateCalendar. Expected Types: HxCalendarData");
        }
        var serialized_args = HxUpdateCalendarArgs_1.serializeHxUpdateCalendarArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(120, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateCalendarItem
    * @param isDraft Can only be false if converting an Appointment to a Meeting with Attendees
    */
    HxActorAPIs.prototype.updateCalendarItem = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in UpdateCalendarItem. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxUpdateCalendarItemArgs_1.serializeHxUpdateCalendarItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(66, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateCalendarItemThisAndForward
    * @param isDraft Can only be false if converting an Appointment to a Meeting with Attendees
    */
    HxActorAPIs.prototype.updateCalendarItemThisAndForward = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAppointmentHeader) {
            throw new Error("Incorrect object type for target in UpdateCalendarItemThisAndForward. Expected Types: HxAppointmentHeader");
        }
        var serialized_args = HxUpdateCalendarItemArgs_1.serializeHxUpdateCalendarItemArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(803, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateCalendarSharingPermission: It can either update calendar sharing permission settings for all delegates or an individual recipient (email address) depending on the args.
    * @param isDelegateRequest Determines whether the args are for all delegates or an individual recipient
    * @param selectedDeliveryOption Needed only when isDelegateRequest is true. selectedDeliveryOption value will be set for all delegates.
    * @param id Needed only when isDelegateRequest is false
    * @param currentDetailLevel Needed only when isDelegateRequest is false
    * @param viewPrivateAppointments Needed only when isDelegateRequest is false
    * @param displayName Optional only when isDelegateRequest is false (not needed at all if isDelegateRequest is true)
    */
    HxActorAPIs.prototype.updateCalendarSharingPermission = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCalendarData) {
            throw new Error("Incorrect object type for target in UpdateCalendarSharingPermission. Expected Types: HxCalendarData");
        }
        var serialized_args = HxUpdateCalendarSharingPermissionArgs_1.serializeHxUpdateCalendarSharingPermissionArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(318, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.updateCategoryColor = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxCategoryData) {
            throw new Error("Incorrect object type for target in UpdateCategoryColor. Expected Types: HxCategoryData");
        }
        var serialized_args = HxUpdateCategoryColorArgs_1.serializeHxUpdateCategoryColorArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(493, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateContact
    * @param hasRemoteId Whether or not ContactsRT contact has a RemoteId set. Only true when reading a contact update.
    * @param importantDates Important dates such as birthdays, anniversaries and other custom values. UTC DateTime property must not contain any time component.
    */
    HxActorAPIs.prototype.updateContact = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxContact) {
            throw new Error("Incorrect object type for target in UpdateContact. Expected Types: HxContact");
        }
        var serialized_args = HxContactArgs_1.serializeHxContactArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(251, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateContactDisplayNameSetting
    * @param IsFirstNameLastNameContactDisplayNameSetting False means that the display name order is last name, first name. True means the opposite
    */
    HxActorAPIs.prototype.updateContactDisplayNameSetting = function (args) {
        var serialized_args = HxUpdateContactDisplayNameSettingArgs_1.serializeHxUpdateContactDisplayNameSettingArgs(args);
        return this.runActor(738, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateDelegates = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in UpdateDelegates. Expected Types: HxAccount");
        }
        var serialized_args = HxUpdateDelegatesArgs_1.serializeHxUpdateDelegatesArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(668, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateDesiredCdnFiles: Updates HxCore's internal CDN file list with case-sensitive relative paths and DownloadBehaviors. HxCore will sync/fetch and manage these files accordingly. Called at most once per boot before any FetchCdnFiles calls. Relative path results are normalized without leading path separator
    */
    HxActorAPIs.prototype.updateDesiredCdnFiles = function (args) {
        var serialized_args = HxUpdateDesiredCdnFilesArgs_1.serializeHxUpdateDesiredCdnFilesArgs(args);
        return this.runActor(727, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateDeviceLocation = function (args) {
        var serialized_args = HxUpdateDeviceLocationArgs_1.serializeHxUpdateDeviceLocationArgs(args);
        return this.runActor(267, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateGroup = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxGroup) {
            throw new Error("Incorrect object type for target in UpdateGroup. Expected Types: HxGroup");
        }
        var serialized_args = HxUpdateGroupArgs_1.serializeHxUpdateGroupArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(567, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.updateInboxRule = function (targetIds, args, actorCompletionNotificationType) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxInboxRule) {
                throw new Error("Incorrect object type for target in UpdateInboxRule. Expected Types: HxInboxRule");
            }
        }
        var serialized_args = HxInboxRuleDataArgs_1.serializeHxInboxRuleDataArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(331, targetIds, JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.updateInlineAttachmentToDraft = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in UpdateInlineAttachmentToDraft. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxUpdateInlineAttachmentToDraftArgs_1.serializeHxUpdateInlineAttachmentToDraftArgs(args);
        return this.runActorWithResultsAsync(48, [targetId], JSON.stringify(serialized_args), actorCompletionNotificationType, false /*isActionUndoable*/);
    };
    HxActorAPIs.prototype.updateIRMExpiredContent = function (targetIds) {
        for (var i = 0; i < targetIds.length; i++) {
            if (targetIds[i].getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
                throw new Error("Incorrect object type for target in UpdateIRMExpiredContent. Expected Types: HxMessageHeader");
            }
        }
        return this.runActor(165, targetIds, '[]', HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateIRMToDraft = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in UpdateIRMToDraft. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxUpdateIRMToDraftArgs_1.serializeHxUpdateIRMToDraftArgs(args);
        return this.runActor(90, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateNetworkStatus = function (args) {
        var serialized_args = HxUpdateNetworkStatusArgs_1.serializeHxUpdateNetworkStatusArgs(args);
        return this.runActor(401, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updatePolicyCompliance = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in UpdatePolicyCompliance. Expected Types: HxAccount");
        }
        var serialized_args = HxUpdatePolicyComplianceArgs_1.serializeHxUpdatePolicyComplianceArgs(args);
        return this.runActor(495, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateReaction = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in UpdateReaction. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxUpdateReactionArgs_1.serializeHxUpdateReactionArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(786, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    HxActorAPIs.prototype.updateRecipient = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxPerson) {
            throw new Error("Incorrect object type for target in UpdateRecipient. Expected Types: HxPerson");
        }
        var serialized_args = HxRecipientDataArgs_1.serializeHxRecipientDataArgs(args);
        return this.runActor(224, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateTeachingTrigger = function (args) {
        var serialized_args = HxUpdateTeachingTriggerArgs_1.serializeHxUpdateTeachingTriggerArgs(args);
        return this.runActor(163, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    /**
    * UpdateToDoTask
    * @param status Changing the status from NotStarted or Started to Completed will implicitly change the CompletedDate to DateTime::Now(). Likewise we'll change the CompletedDate to DateTime::INVALID if changed from Completed to NotStarted or Started. Cannot pass a completedDate at the same time as a status.
    */
    HxActorAPIs.prototype.updateToDoTask = function (targetId, args, actorCompletionNotificationType) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxToDoTask) {
            throw new Error("Incorrect object type for target in UpdateToDoTask. Expected Types: HxToDoTask");
        }
        var serialized_args = HxUpdateToDoTaskArgs_1.serializeHxUpdateToDoTaskArgs(args);
        var completionNotificationType = actorCompletionNotificationType === undefined ? HxEnums.HxActorCompletionNotificationType.CompletedOnStorage : actorCompletionNotificationType;
        return this.runActor(767, [targetId], JSON.stringify(serialized_args), completionNotificationType);
    };
    /**
    * UpdateViewsSortOption: Updates Account::Mail::SortViewsAlphabetically.
                      NOTE: Should only be called on accounts where SupportsNonAlphabeticalViewSort is true
    */
    HxActorAPIs.prototype.updateViewsSortOption = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in UpdateViewsSortOption. Expected Types: HxAccount");
        }
        var serialized_args = HxBoolArgs_1.serializeHxBoolArgs(args);
        return this.runActor(774, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.updateWeatherSettings = function (args) {
        var serialized_args = HxUpdateWeatherSettingsArgs_1.serializeHxUpdateWeatherSettingsArgs(args);
        return this.runActor(431, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.validateCertificates = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in ValidateCertificates. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxValidateCertificatesArgs_1.serializeHxValidateCertificatesArgs(args);
        return this.runActor(167, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.validateMessageSignerCertificates = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in ValidateMessageSignerCertificates. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxDefaultFetchArgs_1.serializeHxDefaultFetchArgs(args);
        return this.runActor(573, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.validateRecipientEncryptionCertificates = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxMessageHeader) {
            throw new Error("Incorrect object type for target in ValidateRecipientEncryptionCertificates. Expected Types: HxMessageHeader");
        }
        var serialized_args = HxValidateRecipientEncryptionCertificatesArgs_1.serializeHxValidateRecipientEncryptionCertificatesArgs(args);
        return this.runActor(574, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.validateUserSmimeCertificates = function (targetId, args) {
        if (targetId.getObjectType() !== HxObjectType_1.default.HxAccount) {
            throw new Error("Incorrect object type for target in ValidateUserSmimeCertificates. Expected Types: HxAccount");
        }
        var serialized_args = HxValidateUserSmimeCertificatesArgs_1.serializeHxValidateUserSmimeCertificatesArgs(args);
        return this.runActor(572, [targetId], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.viewSwitched = function (args) {
        var serialized_args = HxViewSwitchedArgs_1.serializeHxViewSwitchedArgs(args);
        return this.runActor(258, [], JSON.stringify(serialized_args), HxEnums.HxActorCompletionNotificationType.Completed);
    };
    HxActorAPIs.prototype.getProcessIdentifier = function () {
        return this.processIdentifier;
    };
    HxActorAPIs.prototype.getNextCounter = function () {
        return this.globalCounterSeed++;
    };
    HxActorAPIs.prototype.createRequestId = function () {
        return (this.getNextCounter() << 3) | (0x07 & this.getProcessIdentifier());
    };
    HxActorAPIs.prototype.getTargetIdStrings = function (targetIds) {
        var targetIdStrings = [];
        targetIds.forEach(function (targetId) {
            targetIdStrings.push(targetId.toString());
        });
        return targetIdStrings;
    };
    HxActorAPIs.prototype.runActorHelper = function (actorId, targetIds, args, actorCompletionNotificationType) {
        var _this = this;
        var requestId = this.createRequestId();
        return new Promise(function (resolve, reject) {
            return _this._nativeInterop.runActor(actorId, targetIds, args, actorCompletionNotificationType, false /*runAsUndoableAction*/, requestId, function (results) { resolve(HxActorAPIs.parseActorCompletionInfo(results)); }, function (results) { reject(HxActorAPIs.parseActorCompletionInfo(results)); });
        });
    };
    HxActorAPIs.prototype.runActor = function (actorId, targetIds, args, actorCompletionNotificationType) {
        return this.runActorHelper(actorId, this.getTargetIdStrings(targetIds), args, actorCompletionNotificationType);
    };
    HxActorAPIs.prototype.runPairTargetActor = function (actorId, targetIds, args, actorCompletionNotificationType) {
        var flattenedPairTargets = [];
        targetIds.forEach(function (hxObjectIdPair) {
            flattenedPairTargets.push(hxObjectIdPair[0]);
            flattenedPairTargets.push(hxObjectIdPair[1]);
        });
        return this.runActorHelper(actorId, this.getTargetIdStrings(flattenedPairTargets), args, actorCompletionNotificationType);
    };
    HxActorAPIs.prototype.runServerIdTargetActor = function (actorId, targetIds, args, actorCompletionNotificationType) {
        var serverIdTargets = [];
        targetIds.forEach(function (serverIdTarget) {
            serverIdTargets.push(serverIdTarget.accountId.toString());
            serverIdTargets.push(new Buffer(serverIdTarget.itemServerId).toString("utf8"));
        });
        return this.runActorHelper(actorId, serverIdTargets, args, actorCompletionNotificationType);
    };
    HxActorAPIs.prototype.runActorWithUndoHelper = function (actorId, targetIds, args, actorCompletionNotificationType) {
        var _this = this;
        var requestId = this.createRequestId();
        var actorCompletionInfoPromise = new Promise(function (resolve, reject) {
            _this._nativeInterop.runActor(actorId, targetIds, args, actorCompletionNotificationType, true /*runAsUndoableAction*/, requestId, function (results) { resolve(HxActorAPIs.parseActorCompletionInfo(results)); }, function (results) { reject(HxActorAPIs.parseActorCompletionInfo(results)); });
        });
        return new HxActorCompletion_1.default(actorCompletionInfoPromise, requestId);
    };
    HxActorAPIs.prototype.runActorWithUndo = function (actorId, targetIds, args, actorCompletionNotificationType) {
        return this.runActorWithUndoHelper(actorId, this.getTargetIdStrings(targetIds), args, actorCompletionNotificationType);
    };
    HxActorAPIs.prototype.runPairTargetActorWithUndo = function (actorId, targetIds, args, actorCompletionNotificationType) {
        var flattenedPairTargets = [];
        targetIds.forEach(function (hxObjectIdPair) {
            flattenedPairTargets.push(hxObjectIdPair[0]);
            flattenedPairTargets.push(hxObjectIdPair[1]);
        });
        return this.runActorWithUndoHelper(actorId, this.getTargetIdStrings(flattenedPairTargets), args, actorCompletionNotificationType);
    };
    HxActorAPIs.prototype.runActorWithCustomFailureResults = function (actorId, targetIds, args) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this._nativeInterop.runActorWithResults(actorId, _this.getTargetIdStrings(targetIds), args, HxEnums.HxActorCompletionNotificationType.Completed, false /*runAsUndoableAction*/, _this.createRequestId(), resolve, reject, undefined);
        });
    };
    HxActorAPIs.deserializeResults = function (actorId, result) {
        var resultArray = JSON.parse(result);
        var hasActionSucceeded = resultArray[0];
        var resultValues = [];
        if (hasActionSucceeded) {
            resultValues = resultArray[2];
        }
        else {
            if (resultArray[2]) {
                // If FailureResultsBytes are not empty
                resultValues = resultArray[3];
            }
        }
        if (hasActionSucceeded) {
            switch (actorId) {
                case HxActorId_1.default.AddAtMentionRecipient:
                    return HxAddRecipientResults_1.deserializeHxAddRecipientResults(resultValues);
                case HxActorId_1.default.AddAttachmentFileToAppointment:
                    return HxAddAttachmentFileToDraftResults_1.deserializeHxAddAttachmentFileToDraftResults(resultValues);
                case HxActorId_1.default.AddAttachmentFileToDraft:
                    return HxAddAttachmentFileToDraftResults_1.deserializeHxAddAttachmentFileToDraftResults(resultValues);
                case HxActorId_1.default.AddFavoriteGroup:
                    return HxAddFavoriteItemResults_1.deserializeHxAddFavoriteItemResults(resultValues);
                case HxActorId_1.default.AddFavoritePerson:
                    return HxAddFavoriteItemResults_1.deserializeHxAddFavoriteItemResults(resultValues);
                case HxActorId_1.default.AddFavoriteView:
                    return HxAddFavoriteItemResults_1.deserializeHxAddFavoriteItemResults(resultValues);
                case HxActorId_1.default.AddPresenceObservers:
                    return HxPresenceCacheResults_1.deserializeHxPresenceCacheResults(resultValues);
                case HxActorId_1.default.AddRecipient:
                    return HxAddRecipientResults_1.deserializeHxAddRecipientResults(resultValues);
                case HxActorId_1.default.CallGenericRestApi:
                    return HxCallOutlookRestApiResults_1.deserializeHxCallOutlookRestApiResults(resultValues);
                case HxActorId_1.default.CallOutlookRestApi:
                    return HxCallOutlookRestApiResults_1.deserializeHxCallOutlookRestApiResults(resultValues);
                case HxActorId_1.default.CreateAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateArchiveView:
                    return HxCreateViewResults_1.deserializeHxCreateViewResults(resultValues);
                case HxActorId_1.default.CreateCalendar:
                    return HxCalendarDataResults_1.deserializeHxCalendarDataResults(resultValues);
                case HxActorId_1.default.CreateCalendarItem:
                    return HxCreateCalendarItemResults_1.deserializeHxCreateCalendarItemResults(resultValues);
                case HxActorId_1.default.CreateCalendarItemDraftWithAttendees:
                    return HxCreateCalendarItemResults_1.deserializeHxCreateCalendarItemResults(resultValues);
                case HxActorId_1.default.CreateCalendarSharingPermission:
                    return HxCreateCalendarSharingPermissionResults_1.deserializeHxCreateCalendarSharingPermissionResults(resultValues);
                case HxActorId_1.default.CreateContact:
                    return HxCreateContactResults_1.deserializeHxCreateContactResults(resultValues);
                case HxActorId_1.default.CreateGoogleCcAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateGoogleImapAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateICloudCcAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateICloudImapAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateImapAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateImapCcAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateInboxRule:
                    return HxCreateInboxRuleResults_1.deserializeHxCreateInboxRuleResults(resultValues);
                case HxActorId_1.default.CreateManagedOnPremCcAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateMessageFromEML:
                    return HxCreateMessageFromEMLResult_1.deserializeHxCreateMessageFromEMLResult(resultValues);
                case HxActorId_1.default.CreateMsaAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateNewDraft:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.CreateO365Account:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreatePopAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateScheduledView:
                    return HxCreateViewResults_1.deserializeHxCreateViewResults(resultValues);
                case HxActorId_1.default.CreateSearchSession:
                    return HxCreateSearchSessionResults_1.deserializeHxCreateSearchSessionResults(resultValues);
                case HxActorId_1.default.CreateSunriseAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateToDoTaskFromMessage:
                    return HxCreateToDoTaskFromMessageResults_1.deserializeHxCreateToDoTaskFromMessageResults(resultValues);
                case HxActorId_1.default.CreateUnmanagedOnPremCcAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateView:
                    return HxCreateViewResults_1.deserializeHxCreateViewResults(resultValues);
                case HxActorId_1.default.CreateYahooCcAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.CreateYahooImapAccount:
                    return HxCreateAccountResults_1.deserializeHxCreateAccountResults(resultValues);
                case HxActorId_1.default.FetchAccessTokenForAddIn:
                    return HxFetchAccessTokenForAddInResults_1.deserializeHxFetchAccessTokenForAddInResults(resultValues);
                case HxActorId_1.default.FetchAddInMarketplaceUrl:
                    return HxFetchAddInMarketplaceUrlResults_1.deserializeHxFetchAddInMarketplaceUrlResults(resultValues);
                case HxActorId_1.default.FetchAddInRoamingSettings:
                    return HxFetchAddInRoamingSettingsResults_1.deserializeHxFetchAddInRoamingSettingsResults(resultValues);
                case HxActorId_1.default.FetchAddIns:
                    return HxFetchAddInsResults_1.deserializeHxFetchAddInsResults(resultValues);
                case HxActorId_1.default.FetchAppointmentByDeviceId:
                    return HxFetchAppointmentByDeviceIdResults_1.deserializeHxFetchAppointmentByDeviceIdResults(resultValues);
                case HxActorId_1.default.FetchAppointments:
                    return HxFetchAppointmentsResults_1.deserializeHxFetchAppointmentsResults(resultValues);
                case HxActorId_1.default.FetchAttachmentByServerId:
                    return HxFetchAttachmentByServerIdResults_1.deserializeHxFetchAttachmentByServerIdResults(resultValues);
                case HxActorId_1.default.FetchAutoDetect:
                    return HxFetchAutoDetectResults_1.deserializeHxFetchAutoDetectResults(resultValues);
                case HxActorId_1.default.FetchAvailability:
                    return HxFetchAvailabilityResults_1.deserializeHxFetchAvailabilityResults(resultValues);
                case HxActorId_1.default.FetchCalendarSharingPermissionForRecipient:
                    return HxFetchCalendarSharingPermissionForRecipientResults_1.deserializeHxFetchCalendarSharingPermissionForRecipientResults(resultValues);
                case HxActorId_1.default.FetchCdnFiles:
                    return HxFetchCdnFilesResults_1.deserializeHxFetchCdnFilesResults(resultValues);
                case HxActorId_1.default.FetchContactByGraphId:
                    return HxFetchContactResults_1.deserializeHxFetchContactResults(resultValues);
                case HxActorId_1.default.FetchContactByServerId:
                    return HxFetchContactResults_1.deserializeHxFetchContactResults(resultValues);
                case HxActorId_1.default.FetchCustomPropertiesOnAppointment:
                    return HxFetchCustomPropertiesResults_1.deserializeHxFetchCustomPropertiesResults(resultValues);
                case HxActorId_1.default.FetchCustomPropertiesOnMessage:
                    return HxFetchCustomPropertiesResults_1.deserializeHxFetchCustomPropertiesResults(resultValues);
                case HxActorId_1.default.FetchDistributionListMembers:
                    return HxFetchDistributionListMembersResults_1.deserializeHxFetchDistributionListMembersResults(resultValues);
                case HxActorId_1.default.FetchInternetHeadersOnMessage:
                    return HxFetchInternetHeaderResults_1.deserializeHxFetchInternetHeaderResults(resultValues);
                case HxActorId_1.default.FetchIsHxSCapable:
                    return HxFetchIsHxSCapableResults_1.deserializeHxFetchIsHxSCapableResults(resultValues);
                case HxActorId_1.default.FetchLocationByEmail:
                    return HxFetchLocationByEmailResults_1.deserializeHxFetchLocationByEmailResults(resultValues);
                case HxActorId_1.default.FetchLocationSuggestions:
                    return HxLocationSuggestionsResults_1.deserializeHxLocationSuggestionsResults(resultValues);
                case HxActorId_1.default.FetchMeetingTimeSuggestions:
                    return HxFetchMeetingTimeSuggestionsResults_1.deserializeHxFetchMeetingTimeSuggestionsResults(resultValues);
                case HxActorId_1.default.FetchMessageByServerId:
                    return HxFetchMessageByServerIdResults_1.deserializeHxFetchMessageByServerIdResults(resultValues);
                case HxActorId_1.default.FetchMimeContent:
                    return HxFetchMimeContentResults_1.deserializeHxFetchMimeContentResults(resultValues);
                case HxActorId_1.default.FetchMoreMessageHeaders:
                    return HxFetchMoreMessageHeadersResults_1.deserializeHxFetchMoreMessageHeadersResults(resultValues);
                case HxActorId_1.default.FetchPhoto:
                    return HxFetchPhotoResults_1.deserializeHxFetchPhotoResults(resultValues);
                case HxActorId_1.default.FetchRemoteMailboxSyncHealth:
                    return HxFetchRemoteMailboxSyncHealthResults_1.deserializeHxFetchRemoteMailboxSyncHealthResults(resultValues);
                case HxActorId_1.default.FetchSurfaceHubMeetingAttendees:
                    return HxFetchSurfaceHubMeetingAttendeesResults_1.deserializeHxFetchSurfaceHubMeetingAttendeesResults(resultValues);
                case HxActorId_1.default.FindAttachmentsByPerson:
                    return HxFindAttachmentsByPersonResults_1.deserializeHxFindAttachmentsByPersonResults(resultValues);
                case HxActorId_1.default.FindCalendarByDeviceId:
                    return HxCalendarDataResults_1.deserializeHxCalendarDataResults(resultValues);
                case HxActorId_1.default.FindConflictingMeetings:
                    return HxFindConflictingMeetingsResults_1.deserializeHxFindConflictingMeetingsResults(resultValues);
                case HxActorId_1.default.FindContactsBySearchString:
                    return HxFindContactsBySearchStringResults_1.deserializeHxFindContactsBySearchStringResults(resultValues);
                case HxActorId_1.default.FindConversationsByPerson:
                    return HxFindConversationsByPersonResults_1.deserializeHxFindConversationsByPersonResults(resultValues);
                case HxActorId_1.default.FindMeetingsByAttendee:
                    return HxFindMeetingsByAttendeeResults_1.deserializeHxFindMeetingsByAttendeeResults(resultValues);
                case HxActorId_1.default.ForwardAppointment:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.ForwardMessage:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.ForwardMessageAsEmlAttachment:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.GetAppointmentExceptions:
                    return HxGetAppointmentExceptionResults_1.deserializeHxGetAppointmentExceptionResults(resultValues);
                case HxActorId_1.default.GetAppointmentForProtocolActivation:
                    return HxGetAppointmentForProtocolActivationResults_1.deserializeHxGetAppointmentForProtocolActivationResults(resultValues);
                case HxActorId_1.default.GetAppointmentForProtocolActivationByServerId:
                    return HxGetAppointmentForProtocolActivationResults_1.deserializeHxGetAppointmentForProtocolActivationResults(resultValues);
                case HxActorId_1.default.GetCertificateInfoForCertificates:
                    return HxRetrieveCertificateInfoResults_1.deserializeHxRetrieveCertificateInfoResults(resultValues);
                case HxActorId_1.default.GetConversationIndexBasedOnSubstringOrDateTime:
                    return HxGetConversationIndexBasedOnSubstringOrDateTimeResults_1.deserializeHxGetConversationIndexBasedOnSubstringOrDateTimeResults(resultValues);
                case HxActorId_1.default.GetHexizedObjectIds:
                    return HxGetHexizedObjectIdsResults_1.deserializeHxGetHexizedObjectIdsResults(resultValues);
                case HxActorId_1.default.GetHexizedServerIds:
                    return HxGetHexizedServerIdsResults_1.deserializeHxGetHexizedServerIdsResults(resultValues);
                case HxActorId_1.default.GetMessageHeaderForProtocolActivation:
                    return HxGetMessageHeaderForProtocolActivationResults_1.deserializeHxGetMessageHeaderForProtocolActivationResults(resultValues);
                case HxActorId_1.default.GetNextInstanceFromAppointment:
                    return HxGetNextInstanceResults_1.deserializeHxGetNextInstanceResults(resultValues);
                case HxActorId_1.default.GetNextInstanceFromMessage:
                    return HxGetNextInstanceResults_1.deserializeHxGetNextInstanceResults(resultValues);
                case HxActorId_1.default.GetPreviousAndNextAppointmentInstances:
                    return HxGetPreviousAndNextAppointmentInstancesResults_1.deserializeHxGetPreviousAndNextAppointmentInstancesResults(resultValues);
                case HxActorId_1.default.ImportICSFile:
                    return HxOpenICSFileResults_1.deserializeHxOpenICSFileResults(resultValues);
                case HxActorId_1.default.InstallAddIn:
                    return HxInstallAddInResults_1.deserializeHxInstallAddInResults(resultValues);
                case HxActorId_1.default.IsMessageSignerEncryptionCertificateInLocalCache:
                    return HxIsMessageSignerEncryptionCertificateInLocalCacheResults_1.deserializeHxIsMessageSignerEncryptionCertificateInLocalCacheResults(resultValues);
                case HxActorId_1.default.MockActionWithCustomFailureResults:
                    return HxMockResults_1.deserializeHxMockResults(resultValues);
                case HxActorId_1.default.MockActionWithResults:
                    return HxMockResults_1.deserializeHxMockResults(resultValues);
                case HxActorId_1.default.OnWatermarkPushNotification:
                    return HxOnWatermarkPushNotificationResults_1.deserializeHxOnWatermarkPushNotificationResults(resultValues);
                case HxActorId_1.default.PreviewICSFile:
                    return HxPreviewICSFileResults_1.deserializeHxPreviewICSFileResults(resultValues);
                case HxActorId_1.default.PreviewVCFFile:
                    return HxPreviewVCFFileResults_1.deserializeHxPreviewVCFFileResults(resultValues);
                case HxActorId_1.default.ReplyAllToAppointment:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.ReplyAllToMessage:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.ReplyToAppointment:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.ReplyToMessage:
                    return HxCreateDraftResults_1.deserializeHxCreateDraftResults(resultValues);
                case HxActorId_1.default.ReportSearchFeedback:
                    return HxReportSearchFeedbackResults_1.deserializeHxReportSearchFeedbackResults(resultValues);
                case HxActorId_1.default.RequestSearchSuggestions:
                    return HxRequestSearchSuggestionsResults_1.deserializeHxRequestSearchSuggestionsResults(resultValues);
                case HxActorId_1.default.ResolveLocalRecipients:
                    return HxResolveLocalRecipientsResults_1.deserializeHxResolveLocalRecipientsResults(resultValues);
                case HxActorId_1.default.RetrieveCertificateInfo:
                    return HxRetrieveCertificateInfoResults_1.deserializeHxRetrieveCertificateInfoResults(resultValues);
                case HxActorId_1.default.SaveDraft:
                    return HxSaveDraftResults_1.deserializeHxSaveDraftResults(resultValues);
                case HxActorId_1.default.SearchCalendarLegacy:
                    return HxSearchCalendarLegacyResults_1.deserializeHxSearchCalendarLegacyResults(resultValues);
                case HxActorId_1.default.SearchContacts:
                    return HxSearchContactsResults_1.deserializeHxSearchContactsResults(resultValues);
                case HxActorId_1.default.SearchLocalContacts:
                    return HxSearchLocalContactsResults_1.deserializeHxSearchLocalContactsResults(resultValues);
                case HxActorId_1.default.SearchMail:
                    return HxSearchMailResults_1.deserializeHxSearchMailResults(resultValues);
                case HxActorId_1.default.SearchMailNextPage:
                    return HxSearchMailResults_1.deserializeHxSearchMailResults(resultValues);
                case HxActorId_1.default.SearchPeopleForAddressing:
                    return HxSearchPeopleForAddressingResults_1.deserializeHxSearchPeopleForAddressingResults(resultValues);
                case HxActorId_1.default.SetIsDraftEncrypted:
                    return HxSetIsDraftSmimeResults_1.deserializeHxSetIsDraftSmimeResults(resultValues);
                case HxActorId_1.default.SetIsDraftSigned:
                    return HxSetIsDraftSmimeResults_1.deserializeHxSetIsDraftSmimeResults(resultValues);
                case HxActorId_1.default.SetIsDraftSignedAndEncrypted:
                    return HxSetIsDraftSmimeResults_1.deserializeHxSetIsDraftSmimeResults(resultValues);
                case HxActorId_1.default.SetRecipients:
                    return HxSetRecipientsResults_1.deserializeHxSetRecipientsResults(resultValues);
                case HxActorId_1.default.SimulatedWatermarkPushNotification:
                    return HxSimulatedWatermarkPushNotificationResults_1.deserializeHxSimulatedWatermarkPushNotificationResults(resultValues);
                case HxActorId_1.default.UpdateAccount:
                    return HxUpdateAccountResults_1.deserializeHxUpdateAccountResults(resultValues);
                case HxActorId_1.default.UpdateAccountCredentials:
                    return HxUpdateAccountCredentialsResults_1.deserializeHxUpdateAccountCredentialsResults(resultValues);
                case HxActorId_1.default.UpdateInlineAttachmentToDraft:
                    return HxUpdateInlineAttachmentToDraftResults_1.deserializeHxUpdateInlineAttachmentToDraftResults(resultValues);
                default:
                    throw "Actor has no results";
            }
        }
        else {
            return HxFailureResults_1.deserializeHxFailureResults(resultValues);
        }
    };
    HxActorAPIs.prototype.runActorWithResultsAsyncHelper = function (actorId, targetIds, args, actorCompletionNotificationType, runAsUndoableAction) {
        var requestId = this.createRequestId();
        // Typescript doesn't know that we will always assign these before using them, so we need to initialize them to stub callbacks initially
        var resultsAvailableResolver = function (_results) { };
        var resultsAvailableRejecter = function (_results) { };
        var resultsAvailablePromise = new Promise(function (resolve, reject) {
            resultsAvailableResolver = function (results) { resolve(HxActorAPIs.deserializeResults(actorId, results)); };
            resultsAvailableRejecter = function (results) { reject(HxActorAPIs.deserializeResults(actorId, results)); };
        });
        var completionPromise = undefined;
        var completionResolver = undefined;
        var completionRejecter = undefined;
        if (actorCompletionNotificationType !== undefined) {
            completionPromise = new Promise(function (resolve, reject) {
                completionResolver = function (completionResults) { resolve(HxActorAPIs.parseActorCompletionInfo(completionResults)); };
                completionRejecter = function (completionResults) { reject(HxActorAPIs.parseActorCompletionInfo(completionResults)); };
            });
        }
        this._nativeInterop.runActorWithResults(actorId, targetIds, args, actorCompletionNotificationType !== null && actorCompletionNotificationType !== void 0 ? actorCompletionNotificationType : HxEnums.HxActorCompletionNotificationType.CompletedOnStorage, runAsUndoableAction, requestId, resultsAvailableResolver, resultsAvailableRejecter, completionResolver, completionRejecter);
        return new HxActorWithResultsCompletion_1.default(requestId, resultsAvailablePromise, completionPromise);
    };
    HxActorAPIs.prototype.runActorWithResultsAsync = function (actorId, targetIds, args, actorCompletionNotificationType, runAsUndoableAction) {
        return this.runActorWithResultsAsyncHelper(actorId, this.getTargetIdStrings(targetIds), args, actorCompletionNotificationType, runAsUndoableAction);
    };
    HxActorAPIs.prototype.runServerIdTargetActorWithResultsAsync = function (actorId, targetIds, args, actorCompletionNotificationType, runAsUndoableAction) {
        var serverIdTargets = [];
        targetIds.forEach(function (serverIdTarget) {
            serverIdTargets.push(serverIdTarget.accountId.toString());
            serverIdTargets.push(new Buffer(serverIdTarget.itemServerId).toString("utf8"));
        });
        return this.runActorWithResultsAsyncHelper(actorId, serverIdTargets, args, actorCompletionNotificationType, runAsUndoableAction);
    };
    HxActorAPIs.prototype.runPairTargetActorWithResultsAsync = function (actorId, targetIds, args, actorCompletionNotificationType, runAsUndoableAction) {
        var flattenedPairTargets = [];
        targetIds.forEach(function (hxObjectIdPair) {
            flattenedPairTargets.push(hxObjectIdPair[0]);
            flattenedPairTargets.push(hxObjectIdPair[1]);
        });
        return this.runActorWithResultsAsyncHelper(actorId, this.getTargetIdStrings(flattenedPairTargets), args, actorCompletionNotificationType, runAsUndoableAction);
    };
    HxActorAPIs.parseActorCompletionInfo = function (result) {
        var resultArray = JSON.parse(result); // 0-HasActionSucceeded, 1-IsFailureResultsEmpty, 2-FailureResults
        if (resultArray[0]) {
            return new HxActorCompletionInfo_1.default(true, undefined);
        }
        else if (resultArray[1]) {
            // If FailureResultsBytes are not empty
            return new HxActorCompletionInfo_1.default(false, HxFailureResults_1.deserializeHxFailureResults(resultArray[2]));
        }
        else {
            return new HxActorCompletionInfo_1.default(false, undefined);
        }
    };
    return HxActorAPIs;
}());
exports.HxActorAPIs = HxActorAPIs;
function isFailureResults(results) {
    return results.failureResultSentinel !== undefined;
}
exports.isFailureResults = isFailureResults;
exports.default = HxActorAPIs;
